! function(e, t, n) {
    var i = window.matchMedia;
    "undefined" != typeof module && module.exports ? module.exports = n(i) : "function" == typeof define && define.amd ? define(function() {
        return t[e] = n(i)
    }) : t[e] = n(i)
}("enquire", this, function(e) {
    "use strict";

    function t(e, t) {
        for (var n = 0, i = e.length; i > n && !1 !== t(e[n], n); n++);
    }

    function n(e) {
        return "function" == typeof e
    }

    function i(e) {
        this.options = e, !e.deferSetup && this.setup()
    }

    function o(t, n) {
        this.query = t, this.isUnconditional = n, this.handlers = [], this.mql = e(t);
        var i = this;
        this.listener = function(e) {
            i.mql = e, i.assess()
        }, this.mql.addListener(this.listener)
    }

    function r() {
        if (!e) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        this.queries = {}, this.browserIsIncapable = !e("only all").matches
    }
    return i.prototype = {
        setup: function() {
            this.options.setup && this.options.setup(), this.initialised = !0
        },
        on: function() {
            !this.initialised && this.setup(), this.options.match && this.options.match()
        },
        off: function() {
            this.options.unmatch && this.options.unmatch()
        },
        destroy: function() {
            this.options.destroy ? this.options.destroy() : this.off()
        },
        equals: function(e) {
            return this.options === e || this.options.match === e
        }
    }, o.prototype = {
        addHandler: function(e) {
            var t = new i(e);
            this.handlers.push(t), this.matches() && t.on()
        },
        removeHandler: function(e) {
            var n = this.handlers;
            t(n, function(t, i) {
                return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0
            })
        },
        matches: function() {
            return this.mql.matches || this.isUnconditional
        },
        clear: function() {
            t(this.handlers, function(e) {
                e.destroy()
            }), this.mql.removeListener(this.listener), this.handlers.length = 0
        },
        assess: function() {
            var e = this.matches() ? "on" : "off";
            t(this.handlers, function(t) {
                t[e]()
            })
        }
    }, r.prototype = {
        register: function(e, i, r) {
            var s = this.queries,
                a = r && this.browserIsIncapable;
            return s[e] || (s[e] = new o(e, a)), n(i) && (i = {
                    match: i
                }),
                function(e) {
                    return "[object Array]" === Object.prototype.toString.apply(e)
                }(i) || (i = [i]), t(i, function(t) {
                    n(t) && (t = {
                        match: t
                    }), s[e].addHandler(t)
                }), this
        },
        unregister: function(e, t) {
            var n = this.queries[e];
            return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this
        }
    }, new r
}),
function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    function n(e) {
        var t = !!e && "length" in e && e.length,
            n = K.type(e);
        return "function" !== n && !K.isWindow(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }

    function i(e, t, n) {
        if (K.isFunction(t)) return K.grep(e, function(e, i) {
            return !!t.call(e, i, e) !== n
        });
        if (t.nodeType) return K.grep(e, function(e) {
            return e === t !== n
        });
        if ("string" == typeof t) {
            if (ue.test(t)) return K.filter(t, e, n);
            t = K.filter(t, e)
        }
        return K.grep(e, function(e) {
            return V.call(t, e) > -1 !== n
        })
    }

    function o(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }

    function r() {
        B.removeEventListener("DOMContentLoaded", r), e.removeEventListener("load", r), K.ready()
    }

    function s() {
        this.expando = K.expando + s.uid++
    }

    function a(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(xe, "-$&").toLowerCase(), "string" == typeof(n = e.getAttribute(i))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : be.test(n) ? K.parseJSON(n) : n)
                } catch (e) {}
                we.set(e, t, n)
            } else n = void 0;
        return n
    }

    function l(e, t, n, i) {
        var o, r = 1,
            s = 20,
            a = i ? function() {
                return i.cur()
            } : function() {
                return K.css(e, t, "")
            },
            l = a(),
            u = n && n[3] || (K.cssNumber[t] ? "" : "px"),
            c = (K.cssNumber[t] || "px" !== u && +l) && Te.exec(K.css(e, t));
        if (c && c[3] !== u) {
            u = u || c[3], n = n || [], c = +l || 1;
            do {
                c /= r = r || ".5", K.style(e, t, c + u)
            } while (r !== (r = a() / l) && 1 !== r && --s)
        }
        return n && (c = +c || +l || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = o)), o
    }

    function u(e, t) {
        var n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || t && K.nodeName(e, t) ? K.merge([e], n) : n
    }

    function c(e, t) {
        for (var n = 0, i = e.length; i > n; n++) ye.set(e[n], "globalEval", !t || ye.get(t[n], "globalEval"))
    }

    function d(e, t, n, i, o) {
        for (var r, s, a, l, d, p, f = t.createDocumentFragment(), h = [], v = 0, g = e.length; g > v; v++)
            if ((r = e[v]) || 0 === r)
                if ("object" === K.type(r)) K.merge(h, r.nodeType ? [r] : r);
                else if (Ne.test(r)) {
            for (s = s || f.appendChild(t.createElement("div")), a = (Ee.exec(r) || ["", ""])[1].toLowerCase(), l = je[a] || je._default, s.innerHTML = l[1] + K.htmlPrefilter(r) + l[2], p = l[0]; p--;) s = s.lastChild;
            K.merge(h, s.childNodes), (s = f.firstChild).textContent = ""
        } else h.push(t.createTextNode(r));
        for (f.textContent = "", v = 0; r = h[v++];)
            if (i && K.inArray(r, i) > -1) o && o.push(r);
            else if (d = K.contains(r.ownerDocument, r), s = u(f.appendChild(r), "script"), d && c(s), n)
            for (p = 0; r = s[p++];) Ae.test(r.type || "") && n.push(r);
        return f
    }

    function p() {
        return !0
    }

    function f() {
        return !1
    }

    function h() {
        try {
            return B.activeElement
        } catch (e) {}
    }

    function v(e, t, n, i, o, r) {
        var s, a;
        if ("object" == typeof t) {
            for (a in "string" != typeof n && (i = i || n, n = void 0), t) v(e, a, n, i, t[a], r);
            return e
        }
        if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), !1 === o) o = f;
        else if (!o) return e;
        return 1 === r && (s = o, (o = function(e) {
            return K().off(e), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = K.guid++)), e.each(function() {
            K.event.add(this, t, o, i, n)
        })
    }

    function g(e, t) {
        return K.nodeName(e, "table") && K.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function m(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function y(e) {
        var t = _e.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function w(e, t) {
        var n, i, o, r, s, a, l, u;
        if (1 === t.nodeType) {
            if (ye.hasData(e) && (r = ye.access(e), s = ye.set(t, r), u = r.events))
                for (o in delete s.handle, s.events = {}, u)
                    for (n = 0, i = u[o].length; i > n; n++) K.event.add(t, o, u[o][n]);
            we.hasData(e) && (a = we.access(e), l = K.extend({}, a), we.set(t, l))
        }
    }

    function b(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && $e.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }

    function x(e, t, n, i) {
        t = X.apply([], t);
        var o, r, s, a, l, c, p = 0,
            f = e.length,
            h = f - 1,
            v = t[0],
            g = K.isFunction(v);
        if (g || f > 1 && "string" == typeof v && !Z.checkClone && Le.test(v)) return e.each(function(o) {
            var r = e.eq(o);
            g && (t[0] = v.call(this, o, r.html())), x(r, t, n, i)
        });
        if (f && (r = (o = d(t, e[0].ownerDocument, !1, e, i)).firstChild, 1 === o.childNodes.length && (o = r), r || i)) {
            for (a = (s = K.map(u(o, "script"), m)).length; f > p; p++) l = o, p !== h && (l = K.clone(l, !0, !0), a && K.merge(s, u(l, "script"))), n.call(e[p], l, p);
            if (a)
                for (c = s[s.length - 1].ownerDocument, K.map(s, y), p = 0; a > p; p++) l = s[p], Ae.test(l.type || "") && !ye.access(l, "globalEval") && K.contains(c, l) && (l.src ? K._evalUrl && K._evalUrl(l.src) : K.globalEval(l.textContent.replace(ze, "")))
        }
        return e
    }

    function k(e, t, n) {
        for (var i, o = t ? K.filter(t, e) : e, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || K.cleanData(u(i)), i.parentNode && (n && K.contains(i.ownerDocument, i) && c(u(i, "script")), i.parentNode.removeChild(i));
        return e
    }

    function T(e, t) {
        var n = K(t.createElement(e)).appendTo(t.body),
            i = K.css(n[0], "display");
        return n.detach(), i
    }

    function C(e) {
        var t = B,
            n = Fe[e];
        return n || ("none" !== (n = T(e, t)) && n || ((t = (Ie = (Ie || K("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentDocument).write(), t.close(), n = T(e, t), Ie.detach()), Fe[e] = n), n
    }

    function S(e, t, n) {
        var i, o, r, s, a = e.style;
        return "" !== (s = (n = n || We(e)) ? n.getPropertyValue(t) || n[t] : void 0) && void 0 !== s || K.contains(e.ownerDocument, e) || (s = K.style(e, t)), n && !Z.pixelMarginRight() && Re.test(s) && Me.test(t) && (i = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = o, a.maxWidth = r), void 0 !== s ? s + "" : s
    }

    function $(e, t) {
        return {
            get: function() {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments)
            }
        }
    }

    function E(e) {
        if (e in Qe) return e;
        for (var t = e[0].toUpperCase() + e.slice(1), n = Ge.length; n--;)
            if ((e = Ge[n] + t) in Qe) return e
    }

    function A(e, t, n) {
        var i = Te.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
    }

    function j(e, t, n, i, o) {
        for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > r; r += 2) "margin" === n && (s += K.css(e, n + Ce[r], !0, o)), i ? ("content" === n && (s -= K.css(e, "padding" + Ce[r], !0, o)), "margin" !== n && (s -= K.css(e, "border" + Ce[r] + "Width", !0, o))) : (s += K.css(e, "padding" + Ce[r], !0, o), "padding" !== n && (s += K.css(e, "border" + Ce[r] + "Width", !0, o)));
        return s
    }

    function N(t, n, i) {
        var o = !0,
            r = "width" === n ? t.offsetWidth : t.offsetHeight,
            s = We(t),
            a = "border-box" === K.css(t, "boxSizing", !1, s);
        if (B.msFullscreenElement && e.top !== e && t.getClientRects().length && (r = Math.round(100 * t.getBoundingClientRect()[n])), 0 >= r || null == r) {
            if ((0 > (r = S(t, n, s)) || null == r) && (r = t.style[n]), Re.test(r)) return r;
            o = a && (Z.boxSizingReliable() || r === t.style[n]), r = parseFloat(r) || 0
        }
        return r + j(t, n, i || (a ? "border" : "content"), o, s) + "px"
    }

    function D(e, t) {
        for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++)(i = e[s]).style && (r[s] = ye.get(i, "olddisplay"), n = i.style.display, t ? (r[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && Se(i) && (r[s] = ye.access(i, "olddisplay", C(i.nodeName)))) : (o = Se(i), "none" === n && o || ye.set(i, "olddisplay", o ? n : K.css(i, "display"))));
        for (s = 0; a > s; s++)(i = e[s]).style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? r[s] || "" : "none"));
        return e
    }

    function O(e, t, n, i, o) {
        return new O.prototype.init(e, t, n, i, o)
    }

    function H() {
        return e.setTimeout(function() {
            Je = void 0
        }), Je = K.now()
    }

    function q(e, t) {
        var n, i = 0,
            o = {
                height: e
            };
        for (t = t ? 1 : 0; 4 > i; i += 2 - t) o["margin" + (n = Ce[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e), o
    }

    function P(e, t, n) {
        for (var i, o = (L.tweeners[t] || []).concat(L.tweeners["*"]), r = 0, s = o.length; s > r; r++)
            if (i = o[r].call(n, t, e)) return i
    }

    function L(e, t, n) {
        var i, o, r = 0,
            s = L.prefilters.length,
            a = K.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var t = Je || H(), n = Math.max(0, u.startTime + u.duration - t), i = 1 - (n / u.duration || 0), r = 0, s = u.tweens.length; s > r; r++) u.tweens[r].run(i);
                return a.notifyWith(e, [u, i, n]), 1 > i && s ? n : (a.resolveWith(e, [u]), !1)
            },
            u = a.promise({
                elem: e,
                props: K.extend({}, t),
                opts: K.extend(!0, {
                    specialEasing: {},
                    easing: K.easing._default
                }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: Je || H(),
                duration: n.duration,
                tweens: [],
                createTween: function(t, n) {
                    var i = K.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                    return u.tweens.push(i), i
                },
                stop: function(t) {
                    var n = 0,
                        i = t ? u.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; i > n; n++) u.tweens[n].run(1);
                    return t ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t])) : a.rejectWith(e, [u, t]), this
                }
            }),
            c = u.props;
        for (function(e, t) {
                var n, i, o, r, s;
                for (n in e)
                    if (o = t[i = K.camelCase(n)], r = e[n], K.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), (s = K.cssHooks[i]) && "expand" in s)
                        for (n in r = s.expand(r), delete e[i], r) n in e || (e[n] = r[n], t[n] = o);
                    else t[i] = o
            }(c, u.opts.specialEasing); s > r; r++)
            if (i = L.prefilters[r].call(u, e, c, u.opts)) return K.isFunction(i.stop) && (K._queueHooks(u.elem, u.opts.queue).stop = K.proxy(i.stop, i)), i;
        return K.map(c, P, u), K.isFunction(u.opts.start) && u.opts.start.call(e, u), K.fx.timer(K.extend(l, {
            elem: e,
            anim: u,
            queue: u.opts.queue
        })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
    }

    function _(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function z(e) {
        return function(t, n) {
            "string" != typeof t && (n = t, t = "*");
            var i, o = 0,
                r = t.toLowerCase().match(ve) || [];
            if (K.isFunction(n))
                for (; i = r[o++];) "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
        }
    }

    function I(e, t, n, i) {
        function o(a) {
            var l;
            return r[a] = !0, K.each(e[a] || [], function(e, a) {
                var u = a(t, n, i);
                return "string" != typeof u || s || r[u] ? s ? !(l = u) : void 0 : (t.dataTypes.unshift(u), o(u), !1)
            }), l
        }
        var r = {},
            s = e === yt;
        return o(t.dataTypes[0]) || !r["*"] && o("*")
    }

    function F(e, t) {
        var n, i, o = K.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
        return i && K.extend(!0, e, i), e
    }

    function M(e, t, n, i) {
        var o;
        if (K.isArray(t)) K.each(t, function(t, o) {
            n || kt.test(e) ? i(e, o) : M(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, i)
        });
        else if (n || "object" !== K.type(t)) i(e, t);
        else
            for (o in t) M(e + "[" + o + "]", t[o], n, i)
    }

    function R(e) {
        return K.isWindow(e) ? e : 9 === e.nodeType && e.defaultView
    }
    var W = [],
        B = e.document,
        U = W.slice,
        X = W.concat,
        Y = W.push,
        V = W.indexOf,
        G = {},
        Q = G.toString,
        J = G.hasOwnProperty,
        Z = {},
        K = function(e, t) {
            return new K.fn.init(e, t)
        },
        ee = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        te = /^-ms-/,
        ne = /-([\da-z])/gi,
        ie = function(e, t) {
            return t.toUpperCase()
        };
    K.fn = K.prototype = {
        jquery: "2.2.3",
        constructor: K,
        selector: "",
        length: 0,
        toArray: function() {
            return U.call(this)
        },
        get: function(e) {
            return null != e ? 0 > e ? this[e + this.length] : this[e] : U.call(this)
        },
        pushStack: function(e) {
            var t = K.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t
        },
        each: function(e) {
            return K.each(this, e)
        },
        map: function(e) {
            return this.pushStack(K.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(U.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length,
                n = +e + (0 > e ? t : 0);
            return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: Y,
        sort: W.sort,
        splice: W.splice
    }, K.extend = K.fn.extend = function() {
        var e, t, n, i, o, r, s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            u = !1;
        for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || K.isFunction(s) || (s = {}), a === l && (s = this, a--); l > a; a++)
            if (null != (e = arguments[a]))
                for (t in e) n = s[t], s !== (i = e[t]) && (u && i && (K.isPlainObject(i) || (o = K.isArray(i))) ? (o ? (o = !1, r = n && K.isArray(n) ? n : []) : r = n && K.isPlainObject(n) ? n : {}, s[t] = K.extend(u, r, i)) : void 0 !== i && (s[t] = i));
        return s
    }, K.extend({
        expando: "jQuery" + ("2.2.3" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === K.type(e)
        },
        isArray: Array.isArray,
        isWindow: function(e) {
            return null != e && e === e.window
        },
        isNumeric: function(e) {
            var t = e && e.toString();
            return !K.isArray(e) && t - parseFloat(t) + 1 >= 0
        },
        isPlainObject: function(e) {
            var t;
            if ("object" !== K.type(e) || e.nodeType || K.isWindow(e)) return !1;
            if (e.constructor && !J.call(e, "constructor") && !J.call(e.constructor.prototype || {}, "isPrototypeOf")) return !1;
            for (t in e);
            return void 0 === t || J.call(e, t)
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? G[Q.call(e)] || "object" : typeof e
        },
        globalEval: function(e) {
            var t, n = eval;
            (e = K.trim(e)) && (1 === e.indexOf("use strict") ? ((t = B.createElement("script")).text = e, B.head.appendChild(t).parentNode.removeChild(t)) : n(e))
        },
        camelCase: function(e) {
            return e.replace(te, "ms-").replace(ne, ie)
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        },
        each: function(e, t) {
            var i, o = 0;
            if (n(e))
                for (i = e.length; i > o && !1 !== t.call(e[o], o, e[o]); o++);
            else
                for (o in e)
                    if (!1 === t.call(e[o], o, e[o])) break; return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(ee, "")
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (n(Object(e)) ? K.merge(i, "string" == typeof e ? [e] : e) : Y.call(i, e)), i
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : V.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, o = e.length; n > i; i++) e[o++] = t[i];
            return e.length = o, e
        },
        grep: function(e, t, n) {
            for (var i = [], o = 0, r = e.length, s = !n; r > o; o++) !t(e[o], o) !== s && i.push(e[o]);
            return i
        },
        map: function(e, t, i) {
            var o, r, s = 0,
                a = [];
            if (n(e))
                for (o = e.length; o > s; s++) null != (r = t(e[s], s, i)) && a.push(r);
            else
                for (s in e) null != (r = t(e[s], s, i)) && a.push(r);
            return X.apply([], a)
        },
        guid: 1,
        proxy: function(e, t) {
            var n, i, o;
            return "string" == typeof t && (n = e[t], t = e, e = n), K.isFunction(e) ? (i = U.call(arguments, 2), (o = function() {
                return e.apply(t || this, i.concat(U.call(arguments)))
            }).guid = e.guid = e.guid || K.guid++, o) : void 0
        },
        now: Date.now,
        support: Z
    }), "function" == typeof Symbol && (K.fn[Symbol.iterator] = W[Symbol.iterator]), K.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        G["[object " + t + "]"] = t.toLowerCase()
    });
    var oe = function(e) {
        function t(e, t, n, i) {
            var o, r, s, a, l, u, d, f, h = t && t.ownerDocument,
                v = t ? t.nodeType : 9;
            if (n = n || [], "string" != typeof e || !e || 1 !== v && 9 !== v && 11 !== v) return n;
            if (!i && ((t ? t.ownerDocument || t : F) !== O && D(t), t = t || O, q)) {
                if (11 !== v && (u = me.exec(e)))
                    if (o = u[1]) {
                        if (9 === v) {
                            if (!(s = t.getElementById(o))) return n;
                            if (s.id === o) return n.push(s), n
                        } else if (h && (s = h.getElementById(o)) && z(t, s) && s.id === o) return n.push(s), n
                    } else {
                        if (u[2]) return Z.apply(n, t.getElementsByTagName(e)), n;
                        if ((o = u[3]) && x.getElementsByClassName && t.getElementsByClassName) return Z.apply(n, t.getElementsByClassName(o)), n
                    }
                if (x.qsa && !U[e + " "] && (!P || !P.test(e))) {
                    if (1 !== v) h = t, f = e;
                    else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((a = t.getAttribute("id")) ? a = a.replace(we, "\\$&") : t.setAttribute("id", a = I), r = (d = S(e)).length, l = pe.test(a) ? "#" + a : "[id='" + a + "']"; r--;) d[r] = l + " " + p(d[r]);
                        f = d.join(","), h = ye.test(e) && c(t.parentNode) || t
                    }
                    if (f) try {
                        return Z.apply(n, h.querySelectorAll(f)), n
                    } catch (e) {} finally {
                        a === I && t.removeAttribute("id")
                    }
                }
            }
            return E(e.replace(ae, "$1"), t, n, i)
        }

        function n() {
            var e = [];
            return function t(n, i) {
                return e.push(n + " ") > k.cacheLength && delete t[e.shift()], t[n + " "] = i
            }
        }

        function i(e) {
            return e[I] = !0, e
        }

        function o(e) {
            var t = O.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function r(e, t) {
            for (var n = e.split("|"), i = n.length; i--;) k.attrHandle[n[i]] = t
        }

        function s(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || Y) - (~e.sourceIndex || Y);
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t) return -1;
            return e ? 1 : -1
        }

        function a(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }

        function l(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }

        function u(e) {
            return i(function(t) {
                return t = +t, i(function(n, i) {
                    for (var o, r = e([], n.length, t), s = r.length; s--;) n[o = r[s]] && (n[o] = !(i[o] = n[o]))
                })
            })
        }

        function c(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }

        function d() {}

        function p(e) {
            for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
            return i
        }

        function f(e, t, n) {
            var i = t.dir,
                o = n && "parentNode" === i,
                r = R++;
            return t.first ? function(t, n, r) {
                for (; t = t[i];)
                    if (1 === t.nodeType || o) return e(t, n, r)
            } : function(t, n, s) {
                var a, l, u, c = [M, r];
                if (s) {
                    for (; t = t[i];)
                        if ((1 === t.nodeType || o) && e(t, n, s)) return !0
                } else
                    for (; t = t[i];)
                        if (1 === t.nodeType || o) {
                            if ((a = (l = (u = t[I] || (t[I] = {}))[t.uniqueID] || (u[t.uniqueID] = {}))[i]) && a[0] === M && a[1] === r) return c[2] = a[2];
                            if (l[i] = c, c[2] = e(t, n, s)) return !0
                        }
            }
        }

        function h(e) {
            return e.length > 1 ? function(t, n, i) {
                for (var o = e.length; o--;)
                    if (!e[o](t, n, i)) return !1;
                return !0
            } : e[0]
        }

        function v(e, n, i) {
            for (var o = 0, r = n.length; r > o; o++) t(e, n[o], i);
            return i
        }

        function g(e, t, n, i, o) {
            for (var r, s = [], a = 0, l = e.length, u = null != t; l > a; a++)(r = e[a]) && (n && !n(r, i, o) || (s.push(r), u && t.push(a)));
            return s
        }

        function m(e, t, n, o, r, s) {
            return o && !o[I] && (o = m(o)), r && !r[I] && (r = m(r, s)), i(function(i, s, a, l) {
                var u, c, d, p = [],
                    f = [],
                    h = s.length,
                    m = i || v(t || "*", a.nodeType ? [a] : a, []),
                    y = !e || !i && t ? m : g(m, p, e, a, l),
                    w = n ? r || (i ? e : h || o) ? [] : s : y;
                if (n && n(y, w, a, l), o)
                    for (u = g(w, f), o(u, [], a, l), c = u.length; c--;)(d = u[c]) && (w[f[c]] = !(y[f[c]] = d));
                if (i) {
                    if (r || e) {
                        if (r) {
                            for (u = [], c = w.length; c--;)(d = w[c]) && u.push(y[c] = d);
                            r(null, w = [], u, l)
                        }
                        for (c = w.length; c--;)(d = w[c]) && (u = r ? ee(i, d) : p[c]) > -1 && (i[u] = !(s[u] = d))
                    }
                } else w = g(w === s ? w.splice(h, w.length) : w), r ? r(null, s, w, l) : Z.apply(s, w)
            })
        }

        function y(e) {
            for (var t, n, i, o = e.length, r = k.relative[e[0].type], s = r || k.relative[" "], a = r ? 1 : 0, l = f(function(e) {
                    return e === t
                }, s, !0), u = f(function(e) {
                    return ee(t, e) > -1
                }, s, !0), c = [function(e, n, i) {
                    var o = !r && (i || n !== A) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                    return t = null, o
                }]; o > a; a++)
                if (n = k.relative[e[a].type]) c = [f(h(c), n)];
                else {
                    if ((n = k.filter[e[a].type].apply(null, e[a].matches))[I]) {
                        for (i = ++a; o > i && !k.relative[e[i].type]; i++);
                        return m(a > 1 && h(c), a > 1 && p(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(ae, "$1"), n, i > a && y(e.slice(a, i)), o > i && y(e = e.slice(i)), o > i && p(e))
                    }
                    c.push(n)
                }
            return h(c)
        }

        function w(e, n) {
            var o = n.length > 0,
                r = e.length > 0,
                s = function(i, s, a, l, u) {
                    var c, d, p, f = 0,
                        h = "0",
                        v = i && [],
                        m = [],
                        y = A,
                        w = i || r && k.find.TAG("*", u),
                        b = M += null == y ? 1 : Math.random() || .1,
                        x = w.length;
                    for (u && (A = s === O || s || u); h !== x && null != (c = w[h]); h++) {
                        if (r && c) {
                            for (d = 0, s || c.ownerDocument === O || (D(c), a = !q); p = e[d++];)
                                if (p(c, s || O, a)) {
                                    l.push(c);
                                    break
                                }
                            u && (M = b)
                        }
                        o && ((c = !p && c) && f--, i && v.push(c))
                    }
                    if (f += h, o && h !== f) {
                        for (d = 0; p = n[d++];) p(v, m, s, a);
                        if (i) {
                            if (f > 0)
                                for (; h--;) v[h] || m[h] || (m[h] = Q.call(l));
                            m = g(m)
                        }
                        Z.apply(l, m), u && !i && m.length > 0 && f + n.length > 1 && t.uniqueSort(l)
                    }
                    return u && (M = b, A = y), v
                };
            return o ? i(s) : s
        }
        var b, x, k, T, C, S, $, E, A, j, N, D, O, H, q, P, L, _, z, I = "sizzle" + 1 * new Date,
            F = e.document,
            M = 0,
            R = 0,
            W = n(),
            B = n(),
            U = n(),
            X = function(e, t) {
                return e === t && (N = !0), 0
            },
            Y = 1 << 31,
            V = {}.hasOwnProperty,
            G = [],
            Q = G.pop,
            J = G.push,
            Z = G.push,
            K = G.slice,
            ee = function(e, t) {
                for (var n = 0, i = e.length; i > n; n++)
                    if (e[n] === t) return n;
                return -1
            },
            te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            ne = "[\\x20\\t\\r\\n\\f]",
            ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            oe = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ne + "*\\]",
            re = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + oe + ")*)|.*)\\)|)",
            se = new RegExp(ne + "+", "g"),
            ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"),
            le = new RegExp("^" + ne + "*," + ne + "*"),
            ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
            ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
            de = new RegExp(re),
            pe = new RegExp("^" + ie + "$"),
            fe = {
                ID: new RegExp("^#(" + ie + ")"),
                CLASS: new RegExp("^\\.(" + ie + ")"),
                TAG: new RegExp("^(" + ie + "|[*])"),
                ATTR: new RegExp("^" + oe),
                PSEUDO: new RegExp("^" + re),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + te + ")$", "i"),
                needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)", "i")
            },
            he = /^(?:input|select|textarea|button)$/i,
            ve = /^h\d$/i,
            ge = /^[^{]+\{\s*\[native \w/,
            me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ye = /[+~]/,
            we = /'|\\/g,
            be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
            xe = function(e, t, n) {
                var i = "0x" + t - 65536;
                return i != i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
            },
            ke = function() {
                D()
            };
        try {
            Z.apply(G = K.call(F.childNodes), F.childNodes), G[F.childNodes.length].nodeType
        } catch (e) {
            Z = {
                apply: G.length ? function(e, t) {
                    J.apply(e, K.call(t))
                } : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++];);
                    e.length = n - 1
                }
            }
        }
        for (b in x = t.support = {}, C = t.isXML = function(e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName
            }, D = t.setDocument = function(e) {
                var t, n, i = e ? e.ownerDocument || e : F;
                return i !== O && 9 === i.nodeType && i.documentElement ? (H = (O = i).documentElement, q = !C(O), (n = O.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", ke, !1) : n.attachEvent && n.attachEvent("onunload", ke)), x.attributes = o(function(e) {
                    return e.className = "i", !e.getAttribute("className")
                }), x.getElementsByTagName = o(function(e) {
                    return e.appendChild(O.createComment("")), !e.getElementsByTagName("*").length
                }), x.getElementsByClassName = ge.test(O.getElementsByClassName), x.getById = o(function(e) {
                    return H.appendChild(e).id = I, !O.getElementsByName || !O.getElementsByName(I).length
                }), x.getById ? (k.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && q) {
                        var n = t.getElementById(e);
                        return n ? [n] : []
                    }
                }, k.filter.ID = function(e) {
                    var t = e.replace(be, xe);
                    return function(e) {
                        return e.getAttribute("id") === t
                    }
                }) : (delete k.find.ID, k.filter.ID = function(e) {
                    var t = e.replace(be, xe);
                    return function(e) {
                        var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                        return n && n.value === t
                    }
                }), k.find.TAG = x.getElementsByTagName ? function(e, t) {
                    return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : x.qsa ? t.querySelectorAll(e) : void 0
                } : function(e, t) {
                    var n, i = [],
                        o = 0,
                        r = t.getElementsByTagName(e);
                    if ("*" === e) {
                        for (; n = r[o++];) 1 === n.nodeType && i.push(n);
                        return i
                    }
                    return r
                }, k.find.CLASS = x.getElementsByClassName && function(e, t) {
                    return void 0 !== t.getElementsByClassName && q ? t.getElementsByClassName(e) : void 0
                }, L = [], P = [], (x.qsa = ge.test(O.querySelectorAll)) && (o(function(e) {
                    H.appendChild(e).innerHTML = "<a id='" + I + "'></a><select id='" + I + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && P.push("[*^$]=" + ne + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || P.push("\\[" + ne + "*(?:value|" + te + ")"), e.querySelectorAll("[id~=" + I + "-]").length || P.push("~="), e.querySelectorAll(":checked").length || P.push(":checked"), e.querySelectorAll("a#" + I + "+*").length || P.push(".#.+[+~]")
                }), o(function(e) {
                    var t = O.createElement("input");
                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && P.push("name" + ne + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || P.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), P.push(",.*:")
                })), (x.matchesSelector = ge.test(_ = H.matches || H.webkitMatchesSelector || H.mozMatchesSelector || H.oMatchesSelector || H.msMatchesSelector)) && o(function(e) {
                    x.disconnectedMatch = _.call(e, "div"), _.call(e, "[s!='']:x"), L.push("!=", re)
                }), P = P.length && new RegExp(P.join("|")), L = L.length && new RegExp(L.join("|")), t = ge.test(H.compareDocumentPosition), z = t || ge.test(H.contains) ? function(e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                        i = t && t.parentNode;
                    return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
                } : function(e, t) {
                    if (t)
                        for (; t = t.parentNode;)
                            if (t === e) return !0;
                    return !1
                }, X = t ? function(e, t) {
                    if (e === t) return N = !0, 0;
                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !x.sortDetached && t.compareDocumentPosition(e) === n ? e === O || e.ownerDocument === F && z(F, e) ? -1 : t === O || t.ownerDocument === F && z(F, t) ? 1 : j ? ee(j, e) - ee(j, t) : 0 : 4 & n ? -1 : 1)
                } : function(e, t) {
                    if (e === t) return N = !0, 0;
                    var n, i = 0,
                        o = e.parentNode,
                        r = t.parentNode,
                        a = [e],
                        l = [t];
                    if (!o || !r) return e === O ? -1 : t === O ? 1 : o ? -1 : r ? 1 : j ? ee(j, e) - ee(j, t) : 0;
                    if (o === r) return s(e, t);
                    for (n = e; n = n.parentNode;) a.unshift(n);
                    for (n = t; n = n.parentNode;) l.unshift(n);
                    for (; a[i] === l[i];) i++;
                    return i ? s(a[i], l[i]) : a[i] === F ? -1 : l[i] === F ? 1 : 0
                }, O) : O
            }, t.matches = function(e, n) {
                return t(e, null, null, n)
            }, t.matchesSelector = function(e, n) {
                if ((e.ownerDocument || e) !== O && D(e), n = n.replace(ce, "='$1']"), x.matchesSelector && q && !U[n + " "] && (!L || !L.test(n)) && (!P || !P.test(n))) try {
                    var i = _.call(e, n);
                    if (i || x.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
                } catch (e) {}
                return t(n, O, null, [e]).length > 0
            }, t.contains = function(e, t) {
                return (e.ownerDocument || e) !== O && D(e), z(e, t)
            }, t.attr = function(e, t) {
                (e.ownerDocument || e) !== O && D(e);
                var n = k.attrHandle[t.toLowerCase()],
                    i = n && V.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !q) : void 0;
                return void 0 !== i ? i : x.attributes || !q ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
            }, t.error = function(e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }, t.uniqueSort = function(e) {
                var t, n = [],
                    i = 0,
                    o = 0;
                if (N = !x.detectDuplicates, j = !x.sortStable && e.slice(0), e.sort(X), N) {
                    for (; t = e[o++];) t === e[o] && (i = n.push(o));
                    for (; i--;) e.splice(n[i], 1)
                }
                return j = null, e
            }, T = t.getText = function(e) {
                var t, n = "",
                    i = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) n += T(e)
                    } else if (3 === o || 4 === o) return e.nodeValue
                } else
                    for (; t = e[i++];) n += T(t);
                return n
            }, (k = t.selectors = {
                cacheLength: 50,
                createPseudo: i,
                match: fe,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(be, xe), e[3] = (e[3] || e[4] || e[5] || "").replace(be, xe), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, n = !e[6] && e[2];
                        return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && de.test(n) && (t = S(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(be, xe).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t
                        }
                    },
                    CLASS: function(e) {
                        var t = W[e + " "];
                        return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && W(e, function(e) {
                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                        })
                    },
                    ATTR: function(e, n, i) {
                        return function(o) {
                            var r = t.attr(o, e);
                            return null == r ? "!=" === n : !n || (r += "", "=" === n ? r === i : "!=" === n ? r !== i : "^=" === n ? i && 0 === r.indexOf(i) : "*=" === n ? i && r.indexOf(i) > -1 : "$=" === n ? i && r.slice(-i.length) === i : "~=" === n ? (" " + r.replace(se, " ") + " ").indexOf(i) > -1 : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"))
                        }
                    },
                    CHILD: function(e, t, n, i, o) {
                        var r = "nth" !== e.slice(0, 3),
                            s = "last" !== e.slice(-4),
                            a = "of-type" === t;
                        return 1 === i && 0 === o ? function(e) {
                            return !!e.parentNode
                        } : function(t, n, l) {
                            var u, c, d, p, f, h, v = r !== s ? "nextSibling" : "previousSibling",
                                g = t.parentNode,
                                m = a && t.nodeName.toLowerCase(),
                                y = !l && !a,
                                w = !1;
                            if (g) {
                                if (r) {
                                    for (; v;) {
                                        for (p = t; p = p[v];)
                                            if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                        h = v = "only" === e && !h && "nextSibling"
                                    }
                                    return !0
                                }
                                if (h = [s ? g.firstChild : g.lastChild], s && y) {
                                    for (w = (f = (u = (c = (d = (p = g)[I] || (p[I] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === M && u[1]) && u[2], p = f && g.childNodes[f]; p = ++f && p && p[v] || (w = f = 0) || h.pop();)
                                        if (1 === p.nodeType && ++w && p === t) {
                                            c[e] = [M, f, w];
                                            break
                                        }
                                } else if (y && (w = f = (u = (c = (d = (p = t)[I] || (p[I] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === M && u[1]), !1 === w)
                                    for (;
                                        (p = ++f && p && p[v] || (w = f = 0) || h.pop()) && ((a ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) || !++w || (y && ((c = (d = p[I] || (p[I] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [M, w]), p !== t)););
                                return (w -= o) === i || w % i == 0 && w / i >= 0
                            }
                        }
                    },
                    PSEUDO: function(e, n) {
                        var o, r = k.pseudos[e] || k.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                        return r[I] ? r(n) : r.length > 1 ? (o = [e, e, "", n], k.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
                            for (var i, o = r(e, n), s = o.length; s--;) e[i = ee(e, o[s])] = !(t[i] = o[s])
                        }) : function(e) {
                            return r(e, 0, o)
                        }) : r
                    }
                },
                pseudos: {
                    not: i(function(e) {
                        var t = [],
                            n = [],
                            o = $(e.replace(ae, "$1"));
                        return o[I] ? i(function(e, t, n, i) {
                            for (var r, s = o(e, null, i, []), a = e.length; a--;)(r = s[a]) && (e[a] = !(t[a] = r))
                        }) : function(e, i, r) {
                            return t[0] = e, o(t, null, r, n), t[0] = null, !n.pop()
                        }
                    }),
                    has: i(function(e) {
                        return function(n) {
                            return t(e, n).length > 0
                        }
                    }),
                    contains: i(function(e) {
                        return e = e.replace(be, xe),
                            function(t) {
                                return (t.textContent || t.innerText || T(t)).indexOf(e) > -1
                            }
                    }),
                    lang: i(function(e) {
                        return pe.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(be, xe).toLowerCase(),
                            function(t) {
                                var n;
                                do {
                                    if (n = q ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1
                            }
                    }),
                    target: function(t) {
                        var n = e.location && e.location.hash;
                        return n && n.slice(1) === t.id
                    },
                    root: function(e) {
                        return e === H
                    },
                    focus: function(e) {
                        return e === O.activeElement && (!O.hasFocus || O.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: function(e) {
                        return !1 === e.disabled
                    },
                    disabled: function(e) {
                        return !0 === e.disabled
                    },
                    checked: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !k.pseudos.empty(e)
                    },
                    header: function(e) {
                        return ve.test(e.nodeName)
                    },
                    input: function(e) {
                        return he.test(e.nodeName)
                    },
                    button: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function(e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: u(function() {
                        return [0]
                    }),
                    last: u(function(e, t) {
                        return [t - 1]
                    }),
                    eq: u(function(e, t, n) {
                        return [0 > n ? n + t : n]
                    }),
                    even: u(function(e, t) {
                        for (var n = 0; t > n; n += 2) e.push(n);
                        return e
                    }),
                    odd: u(function(e, t) {
                        for (var n = 1; t > n; n += 2) e.push(n);
                        return e
                    }),
                    lt: u(function(e, t, n) {
                        for (var i = 0 > n ? n + t : n; --i >= 0;) e.push(i);
                        return e
                    }),
                    gt: u(function(e, t, n) {
                        for (var i = 0 > n ? n + t : n; ++i < t;) e.push(i);
                        return e
                    })
                }
            }).pseudos.nth = k.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) k.pseudos[b] = a(b);
        for (b in {
                submit: !0,
                reset: !0
            }) k.pseudos[b] = l(b);
        return d.prototype = k.filters = k.pseudos, k.setFilters = new d, S = t.tokenize = function(e, n) {
            var i, o, r, s, a, l, u, c = B[e + " "];
            if (c) return n ? 0 : c.slice(0);
            for (a = e, l = [], u = k.preFilter; a;) {
                for (s in i && !(o = le.exec(a)) || (o && (a = a.slice(o[0].length) || a), l.push(r = [])), i = !1, (o = ue.exec(a)) && (i = o.shift(), r.push({
                        value: i,
                        type: o[0].replace(ae, " ")
                    }), a = a.slice(i.length)), k.filter) !(o = fe[s].exec(a)) || u[s] && !(o = u[s](o)) || (i = o.shift(), r.push({
                    value: i,
                    type: s,
                    matches: o
                }), a = a.slice(i.length));
                if (!i) break
            }
            return n ? a.length : a ? t.error(e) : B(e, l).slice(0)
        }, $ = t.compile = function(e, t) {
            var n, i = [],
                o = [],
                r = U[e + " "];
            if (!r) {
                for (t || (t = S(e)), n = t.length; n--;)(r = y(t[n]))[I] ? i.push(r) : o.push(r);
                (r = U(e, w(o, i))).selector = e
            }
            return r
        }, E = t.select = function(e, t, n, i) {
            var o, r, s, a, l, u = "function" == typeof e && e,
                d = !i && S(e = u.selector || e);
            if (n = n || [], 1 === d.length) {
                if ((r = d[0] = d[0].slice(0)).length > 2 && "ID" === (s = r[0]).type && x.getById && 9 === t.nodeType && q && k.relative[r[1].type]) {
                    if (!(t = (k.find.ID(s.matches[0].replace(be, xe), t) || [])[0])) return n;
                    u && (t = t.parentNode), e = e.slice(r.shift().value.length)
                }
                for (o = fe.needsContext.test(e) ? 0 : r.length; o-- && (s = r[o], !k.relative[a = s.type]);)
                    if ((l = k.find[a]) && (i = l(s.matches[0].replace(be, xe), ye.test(r[0].type) && c(t.parentNode) || t))) {
                        if (r.splice(o, 1), !(e = i.length && p(r))) return Z.apply(n, i), n;
                        break
                    }
            }
            return (u || $(e, d))(i, t, !q, n, !t || ye.test(e) && c(t.parentNode) || t), n
        }, x.sortStable = I.split("").sort(X).join("") === I, x.detectDuplicates = !!N, D(), x.sortDetached = o(function(e) {
            return 1 & e.compareDocumentPosition(O.createElement("div"))
        }), o(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || r("type|href|height|width", function(e, t, n) {
            return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), x.attributes && o(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || r("value", function(e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
        }), o(function(e) {
            return null == e.getAttribute("disabled")
        }) || r(te, function(e, t, n) {
            var i;
            return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }), t
    }(e);
    K.find = oe, K.expr = oe.selectors, K.expr[":"] = K.expr.pseudos, K.uniqueSort = K.unique = oe.uniqueSort, K.text = oe.getText, K.isXMLDoc = oe.isXML, K.contains = oe.contains;
    var re = function(e, t, n) {
            for (var i = [], o = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;)
                if (1 === e.nodeType) {
                    if (o && K(e).is(n)) break;
                    i.push(e)
                }
            return i
        },
        se = function(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n
        },
        ae = K.expr.match.needsContext,
        le = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        ue = /^.[^:#\[\.,]*$/;
    K.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? K.find.matchesSelector(i, e) ? [i] : [] : K.find.matches(e, K.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, K.fn.extend({
        find: function(e) {
            var t, n = this.length,
                i = [],
                o = this;
            if ("string" != typeof e) return this.pushStack(K(e).filter(function() {
                for (t = 0; n > t; t++)
                    if (K.contains(o[t], this)) return !0
            }));
            for (t = 0; n > t; t++) K.find(e, o[t], i);
            return (i = this.pushStack(n > 1 ? K.unique(i) : i)).selector = this.selector ? this.selector + " " + e : e, i
        },
        filter: function(e) {
            return this.pushStack(i(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(i(this, e || [], !0))
        },
        is: function(e) {
            return !!i(this, "string" == typeof e && ae.test(e) ? K(e) : e || [], !1).length
        }
    });
    var ce, de = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (K.fn.init = function(e, t, n) {
        var i, o;
        if (!e) return this;
        if (n = n || ce, "string" == typeof e) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : de.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (t = t instanceof K ? t[0] : t, K.merge(this, K.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : B, !0)), le.test(i[1]) && K.isPlainObject(t))
                    for (i in t) K.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this
            }
            return (o = B.getElementById(i[2])) && o.parentNode && (this.length = 1, this[0] = o), this.context = B, this.selector = e, this
        }
        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : K.isFunction(e) ? void 0 !== n.ready ? n.ready(e) : e(K) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), K.makeArray(e, this))
    }).prototype = K.fn, ce = K(B);
    var pe = /^(?:parents|prev(?:Until|All))/,
        fe = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    K.fn.extend({
        has: function(e) {
            var t = K(e, this),
                n = t.length;
            return this.filter(function() {
                for (var e = 0; n > e; e++)
                    if (K.contains(this, t[e])) return !0
            })
        },
        closest: function(e, t) {
            for (var n, i = 0, o = this.length, r = [], s = ae.test(e) || "string" != typeof e ? K(e, t || this.context) : 0; o > i; i++)
                for (n = this[i]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && K.find.matchesSelector(n, e))) {
                        r.push(n);
                        break
                    }
            return this.pushStack(r.length > 1 ? K.uniqueSort(r) : r)
        },
        index: function(e) {
            return e ? "string" == typeof e ? V.call(K(e), this[0]) : V.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(K.uniqueSort(K.merge(this.get(), K(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), K.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return re(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return re(e, "parentNode", n)
        },
        next: function(e) {
            return o(e, "nextSibling")
        },
        prev: function(e) {
            return o(e, "previousSibling")
        },
        nextAll: function(e) {
            return re(e, "nextSibling")
        },
        prevAll: function(e) {
            return re(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return re(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return re(e, "previousSibling", n)
        },
        siblings: function(e) {
            return se((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return se(e.firstChild)
        },
        contents: function(e) {
            return e.contentDocument || K.merge([], e.childNodes)
        }
    }, function(e, t) {
        K.fn[e] = function(n, i) {
            var o = K.map(this, t, n);
            return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = K.filter(i, o)), this.length > 1 && (fe[e] || K.uniqueSort(o), pe.test(e) && o.reverse()), this.pushStack(o)
        }
    });
    var he, ve = /\S+/g;
    K.Callbacks = function(e) {
        e = "string" == typeof e ? function(e) {
            var t = {};
            return K.each(e.match(ve) || [], function(e, n) {
                t[n] = !0
            }), t
        }(e) : K.extend({}, e);
        var t, n, i, o, r = [],
            s = [],
            a = -1,
            l = function() {
                for (o = e.once, i = t = !0; s.length; a = -1)
                    for (n = s.shift(); ++a < r.length;) !1 === r[a].apply(n[0], n[1]) && e.stopOnFalse && (a = r.length, n = !1);
                e.memory || (n = !1), t = !1, o && (r = n ? [] : "")
            },
            u = {
                add: function() {
                    return r && (n && !t && (a = r.length - 1, s.push(n)), function t(n) {
                        K.each(n, function(n, i) {
                            K.isFunction(i) ? e.unique && u.has(i) || r.push(i) : i && i.length && "string" !== K.type(i) && t(i)
                        })
                    }(arguments), n && !t && l()), this
                },
                remove: function() {
                    return K.each(arguments, function(e, t) {
                        for (var n;
                            (n = K.inArray(t, r, n)) > -1;) r.splice(n, 1), a >= n && a--
                    }), this
                },
                has: function(e) {
                    return e ? K.inArray(e, r) > -1 : r.length > 0
                },
                empty: function() {
                    return r && (r = []), this
                },
                disable: function() {
                    return o = s = [], r = n = "", this
                },
                disabled: function() {
                    return !r
                },
                lock: function() {
                    return o = s = [], n || (r = n = ""), this
                },
                locked: function() {
                    return !!o
                },
                fireWith: function(e, n) {
                    return o || (n = [e, (n = n || []).slice ? n.slice() : n], s.push(n), t || l()), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!i
                }
            };
        return u
    }, K.extend({
        Deferred: function(e) {
            var t = [
                    ["resolve", "done", K.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", K.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", K.Callbacks("memory")]
                ],
                n = "pending",
                i = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return o.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var e = arguments;
                        return K.Deferred(function(n) {
                            K.each(t, function(t, r) {
                                var s = K.isFunction(e[t]) && e[t];
                                o[r[1]](function() {
                                    var e = s && s.apply(this, arguments);
                                    e && K.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this === i ? n.promise() : this, s ? [e] : arguments)
                                })
                            }), e = null
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? K.extend(e, i) : i
                    }
                },
                o = {};
            return i.pipe = i.then, K.each(t, function(e, r) {
                var s = r[2],
                    a = r[3];
                i[r[1]] = s.add, a && s.add(function() {
                    n = a
                }, t[1 ^ e][2].disable, t[2][2].lock), o[r[0]] = function() {
                    return o[r[0] + "With"](this === o ? i : this, arguments), this
                }, o[r[0] + "With"] = s.fireWith
            }), i.promise(o), e && e.call(o, o), o
        },
        when: function(e) {
            var t, n, i, o = 0,
                r = U.call(arguments),
                s = r.length,
                a = 1 !== s || e && K.isFunction(e.promise) ? s : 0,
                l = 1 === a ? e : K.Deferred(),
                u = function(e, n, i) {
                    return function(o) {
                        n[e] = this, i[e] = arguments.length > 1 ? U.call(arguments) : o, i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i)
                    }
                };
            if (s > 1)
                for (t = new Array(s), n = new Array(s), i = new Array(s); s > o; o++) r[o] && K.isFunction(r[o].promise) ? r[o].promise().progress(u(o, n, t)).done(u(o, i, r)).fail(l.reject) : --a;
            return a || l.resolveWith(i, r), l.promise()
        }
    }), K.fn.ready = function(e) {
        return K.ready.promise().done(e), this
    }, K.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? K.readyWait++ : K.ready(!0)
        },
        ready: function(e) {
            (!0 === e ? --K.readyWait : K.isReady) || (K.isReady = !0, !0 !== e && --K.readyWait > 0 || (he.resolveWith(B, [K]), K.fn.triggerHandler && (K(B).triggerHandler("ready"), K(B).off("ready"))))
        }
    }), K.ready.promise = function(t) {
        return he || (he = K.Deferred(), "complete" === B.readyState || "loading" !== B.readyState && !B.documentElement.doScroll ? e.setTimeout(K.ready) : (B.addEventListener("DOMContentLoaded", r), e.addEventListener("load", r))), he.promise(t)
    }, K.ready.promise();
    var ge = function(e, t, n, i, o, r, s) {
            var a = 0,
                l = e.length,
                u = null == n;
            if ("object" === K.type(n))
                for (a in o = !0, n) ge(e, t, a, n[a], !0, r, s);
            else if (void 0 !== i && (o = !0, K.isFunction(i) || (s = !0), u && (s ? (t.call(e, i), t = null) : (u = t, t = function(e, t, n) {
                    return u.call(K(e), n)
                })), t))
                for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
            return o ? e : u ? t.call(e) : l ? t(e[0], n) : r
        },
        me = function(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
        };
    s.uid = 1, s.prototype = {
        register: function(e, t) {
            var n = t || {};
            return e.nodeType ? e[this.expando] = n : Object.defineProperty(e, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }), e[this.expando]
        },
        cache: function(e) {
            if (!me(e)) return {};
            var t = e[this.expando];
            return t || (t = {}, me(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))), t
        },
        set: function(e, t, n) {
            var i, o = this.cache(e);
            if ("string" == typeof t) o[t] = n;
            else
                for (i in t) o[i] = t[i];
            return o
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t]
        },
        access: function(e, t, n) {
            var i;
            return void 0 === t || t && "string" == typeof t && void 0 === n ? void 0 !== (i = this.get(e, t)) ? i : this.get(e, K.camelCase(t)) : (this.set(e, t, n), void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i, o, r = e[this.expando];
            if (void 0 !== r) {
                if (void 0 === t) this.register(e);
                else {
                    K.isArray(t) ? i = t.concat(t.map(K.camelCase)) : (o = K.camelCase(t), t in r ? i = [t, o] : i = (i = o) in r ? [i] : i.match(ve) || []), n = i.length;
                    for (; n--;) delete r[i[n]]
                }(void 0 === t || K.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !K.isEmptyObject(t)
        }
    };
    var ye = new s,
        we = new s,
        be = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        xe = /[A-Z]/g;
    K.extend({
        hasData: function(e) {
            return we.hasData(e) || ye.hasData(e)
        },
        data: function(e, t, n) {
            return we.access(e, t, n)
        },
        removeData: function(e, t) {
            we.remove(e, t)
        },
        _data: function(e, t, n) {
            return ye.access(e, t, n)
        },
        _removeData: function(e, t) {
            ye.remove(e, t)
        }
    }), K.fn.extend({
        data: function(e, t) {
            var n, i, o, r = this[0],
                s = r && r.attributes;
            if (void 0 === e) {
                if (this.length && (o = we.get(r), 1 === r.nodeType && !ye.get(r, "hasDataAttrs"))) {
                    for (n = s.length; n--;) s[n] && (0 === (i = s[n].name).indexOf("data-") && (i = K.camelCase(i.slice(5)), a(r, i, o[i])));
                    ye.set(r, "hasDataAttrs", !0)
                }
                return o
            }
            return "object" == typeof e ? this.each(function() {
                we.set(this, e)
            }) : ge(this, function(t) {
                var n, i;
                if (r && void 0 === t) {
                    if (void 0 !== (n = we.get(r, e) || we.get(r, e.replace(xe, "-$&").toLowerCase()))) return n;
                    if (i = K.camelCase(e), void 0 !== (n = we.get(r, i))) return n;
                    if (void 0 !== (n = a(r, i, void 0))) return n
                } else i = K.camelCase(e), this.each(function() {
                    var n = we.get(this, i);
                    we.set(this, i, t), e.indexOf("-") > -1 && void 0 !== n && we.set(this, e, t)
                })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                we.remove(this, e)
            })
        }
    }), K.extend({
        queue: function(e, t, n) {
            var i;
            return e ? (t = (t || "fx") + "queue", i = ye.get(e, t), n && (!i || K.isArray(n) ? i = ye.access(e, t, K.makeArray(n)) : i.push(n)), i || []) : void 0
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = K.queue(e, t),
                i = n.length,
                o = n.shift(),
                r = K._queueHooks(e, t);
            "inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, function() {
                K.dequeue(e, t)
            }, r)), !i && r && r.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return ye.get(e, n) || ye.access(e, n, {
                empty: K.Callbacks("once memory").add(function() {
                    ye.remove(e, [t + "queue", n])
                })
            })
        }
    }), K.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? K.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = K.queue(this, e, t);
                K._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && K.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                K.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, i = 1,
                o = K.Deferred(),
                r = this,
                s = this.length,
                a = function() {
                    --i || o.resolveWith(r, [r])
                };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;)(n = ye.get(r[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
            return a(), o.promise(t)
        }
    });
    var ke = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        Te = new RegExp("^(?:([+-])=|)(" + ke + ")([a-z%]*)$", "i"),
        Ce = ["Top", "Right", "Bottom", "Left"],
        Se = function(e, t) {
            return e = t || e, "none" === K.css(e, "display") || !K.contains(e.ownerDocument, e)
        },
        $e = /^(?:checkbox|radio)$/i,
        Ee = /<([\w:-]+)/,
        Ae = /^$|\/(?:java|ecma)script/i,
        je = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
    je.optgroup = je.option, je.tbody = je.tfoot = je.colgroup = je.caption = je.thead, je.th = je.td;
    var Ne = /<|&#?\w+;/;
    ! function() {
        var e = B.createDocumentFragment().appendChild(B.createElement("div")),
            t = B.createElement("input");
        t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), Z.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", Z.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var De = /^key/,
        Oe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        He = /^([^.]*)(?:\.(.+)|)/;
    K.event = {
        global: {},
        add: function(e, t, n, i, o) {
            var r, s, a, l, u, c, d, p, f, h, v, g = ye.get(e);
            if (g)
                for (n.handler && (n = (r = n).handler, o = r.selector), n.guid || (n.guid = K.guid++), (l = g.events) || (l = g.events = {}), (s = g.handle) || (s = g.handle = function(t) {
                        return void 0 !== K && K.event.triggered !== t.type ? K.event.dispatch.apply(e, arguments) : void 0
                    }), u = (t = (t || "").match(ve) || [""]).length; u--;) f = v = (a = He.exec(t[u]) || [])[1], h = (a[2] || "").split(".").sort(), f && (d = K.event.special[f] || {}, f = (o ? d.delegateType : d.bindType) || f, d = K.event.special[f] || {}, c = K.extend({
                    type: f,
                    origType: v,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: o,
                    needsContext: o && K.expr.match.needsContext.test(o),
                    namespace: h.join(".")
                }, r), (p = l[f]) || ((p = l[f] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(e, i, h, s) || e.addEventListener && e.addEventListener(f, s)), d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, c) : p.push(c), K.event.global[f] = !0)
        },
        remove: function(e, t, n, i, o) {
            var r, s, a, l, u, c, d, p, f, h, v, g = ye.hasData(e) && ye.get(e);
            if (g && (l = g.events)) {
                for (u = (t = (t || "").match(ve) || [""]).length; u--;)
                    if (f = v = (a = He.exec(t[u]) || [])[1], h = (a[2] || "").split(".").sort(), f) {
                        for (d = K.event.special[f] || {}, p = l[f = (i ? d.delegateType : d.bindType) || f] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) c = p[r], !o && v !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (p.splice(r, 1), c.selector && p.delegateCount--, d.remove && d.remove.call(e, c));
                        s && !p.length && (d.teardown && !1 !== d.teardown.call(e, h, g.handle) || K.removeEvent(e, f, g.handle), delete l[f])
                    } else
                        for (f in l) K.event.remove(e, f + t[u], n, i, !0);
                K.isEmptyObject(l) && ye.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            e = K.event.fix(e);
            var t, n, i, o, r, s = [],
                a = U.call(arguments),
                l = (ye.get(this, "events") || {})[e.type] || [],
                u = K.event.special[e.type] || {};
            if (a[0] = e, e.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, e)) {
                for (s = K.event.handlers.call(this, e, l), t = 0;
                    (o = s[t++]) && !e.isPropagationStopped();)
                    for (e.currentTarget = o.elem, n = 0;
                        (r = o.handlers[n++]) && !e.isImmediatePropagationStopped();) e.rnamespace && !e.rnamespace.test(r.namespace) || (e.handleObj = r, e.data = r.data, void 0 !== (i = ((K.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) && !1 === (e.result = i) && (e.preventDefault(), e.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, e), e.result
            }
        },
        handlers: function(e, t) {
            var n, i, o, r, s = [],
                a = t.delegateCount,
                l = e.target;
            if (a && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                        for (i = [], n = 0; a > n; n++) void 0 === i[o = (r = t[n]).selector + " "] && (i[o] = r.needsContext ? K(o, this).index(l) > -1 : K.find(o, this, null, [l]).length), i[o] && i.push(r);
                        i.length && s.push({
                            elem: l,
                            handlers: i
                        })
                    }
            return a < t.length && s.push({
                elem: this,
                handlers: t.slice(a)
            }), s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var n, i, o, r = t.button;
                return null == e.pageX && null != t.clientX && (i = (n = e.target.ownerDocument || B).documentElement, o = n.body, e.pageX = t.clientX + (i && i.scrollLeft || o && o.scrollLeft || 0) - (i && i.clientLeft || o && o.clientLeft || 0), e.pageY = t.clientY + (i && i.scrollTop || o && o.scrollTop || 0) - (i && i.clientTop || o && o.clientTop || 0)), e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0), e
            }
        },
        fix: function(e) {
            if (e[K.expando]) return e;
            var t, n, i, o = e.type,
                r = e,
                s = this.fixHooks[o];
            for (s || (this.fixHooks[o] = s = Oe.test(o) ? this.mouseHooks : De.test(o) ? this.keyHooks : {}), i = s.props ? this.props.concat(s.props) : this.props, e = new K.Event(r), t = i.length; t--;) e[n = i[t]] = r[n];
            return e.target || (e.target = B), 3 === e.target.nodeType && (e.target = e.target.parentNode), s.filter ? s.filter(e, r) : e
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== h() && this.focus ? (this.focus(), !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === h() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && K.nodeName(this, "input") ? (this.click(), !1) : void 0
                },
                _default: function(e) {
                    return K.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, K.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }, K.Event = function(e, t) {
        return this instanceof K.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? p : f) : this.type = e, t && K.extend(this, t), this.timeStamp = e && e.timeStamp || K.now(), void(this[K.expando] = !0)) : new K.Event(e, t)
    }, K.Event.prototype = {
        constructor: K.Event,
        isDefaultPrevented: f,
        isPropagationStopped: f,
        isImmediatePropagationStopped: f,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = p, e && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = p, e && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = p, e && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, K.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        K.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, i = e.relatedTarget,
                    o = e.handleObj;
                return i && (i === this || K.contains(this, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n
            }
        }
    }), K.fn.extend({
        on: function(e, t, n, i) {
            return v(this, e, t, n, i)
        },
        one: function(e, t, n, i) {
            return v(this, e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, o;
            if (e && e.preventDefault && e.handleObj) return i = e.handleObj, K(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" == typeof e) {
                for (o in e) this.off(o, t, e[o]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = f), this.each(function() {
                K.event.remove(this, e, n, t)
            })
        }
    });
    var qe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        Pe = /<script|<style|<link/i,
        Le = /checked\s*(?:[^=]|=\s*.checked.)/i,
        _e = /^true\/(.*)/,
        ze = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    K.extend({
        htmlPrefilter: function(e) {
            return e.replace(qe, "<$1></$2>")
        },
        clone: function(e, t, n) {
            var i, o, r, s, a = e.cloneNode(!0),
                l = K.contains(e.ownerDocument, e);
            if (!(Z.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || K.isXMLDoc(e)))
                for (s = u(a), i = 0, o = (r = u(e)).length; o > i; i++) b(r[i], s[i]);
            if (t)
                if (n)
                    for (r = r || u(e), s = s || u(a), i = 0, o = r.length; o > i; i++) w(r[i], s[i]);
                else w(e, a);
            return (s = u(a, "script")).length > 0 && c(s, !l && u(e, "script")), a
        },
        cleanData: function(e) {
            for (var t, n, i, o = K.event.special, r = 0; void 0 !== (n = e[r]); r++)
                if (me(n)) {
                    if (t = n[ye.expando]) {
                        if (t.events)
                            for (i in t.events) o[i] ? K.event.remove(n, i) : K.removeEvent(n, i, t.handle);
                        n[ye.expando] = void 0
                    }
                    n[we.expando] && (n[we.expando] = void 0)
                }
        }
    }), K.fn.extend({
        domManip: x,
        detach: function(e) {
            return k(this, e, !0)
        },
        remove: function(e) {
            return k(this, e)
        },
        text: function(e) {
            return ge(this, function(e) {
                return void 0 === e ? K.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return x(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || g(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return x(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = g(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return x(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return x(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (K.cleanData(u(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return K.clone(this, e, t)
            })
        },
        html: function(e) {
            return ge(this, function(e) {
                var t = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Pe.test(e) && !je[(Ee.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = K.htmlPrefilter(e);
                    try {
                        for (; i > n; n++) 1 === (t = this[n] || {}).nodeType && (K.cleanData(u(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return x(this, arguments, function(t) {
                var n = this.parentNode;
                K.inArray(this, e) < 0 && (K.cleanData(u(this)), n && n.replaceChild(t, this))
            }, e)
        }
    }), K.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        K.fn[e] = function(e) {
            for (var n, i = [], o = K(e), r = o.length - 1, s = 0; r >= s; s++) n = s === r ? this : this.clone(!0), K(o[s])[t](n), Y.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Ie, Fe = {
            HTML: "block",
            BODY: "block"
        },
        Me = /^margin/,
        Re = new RegExp("^(" + ke + ")(?!px)[a-z%]+$", "i"),
        We = function(t) {
            var n = t.ownerDocument.defaultView;
            return n && n.opener || (n = e), n.getComputedStyle(t)
        },
        Be = function(e, t, n, i) {
            var o, r, s = {};
            for (r in t) s[r] = e.style[r], e.style[r] = t[r];
            for (r in o = n.apply(e, i || []), t) e.style[r] = s[r];
            return o
        },
        Ue = B.documentElement;
    ! function() {
        function t() {
            a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Ue.appendChild(s);
            var t = e.getComputedStyle(a);
            n = "1%" !== t.top, r = "2px" === t.marginLeft, i = "4px" === t.width, a.style.marginRight = "50%", o = "4px" === t.marginRight, Ue.removeChild(s)
        }
        var n, i, o, r, s = B.createElement("div"),
            a = B.createElement("div");
        a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", Z.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), K.extend(Z, {
            pixelPosition: function() {
                return t(), n
            },
            boxSizingReliable: function() {
                return null == i && t(), i
            },
            pixelMarginRight: function() {
                return null == i && t(), o
            },
            reliableMarginLeft: function() {
                return null == i && t(), r
            },
            reliableMarginRight: function() {
                var t, n = a.appendChild(B.createElement("div"));
                return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", a.style.width = "1px", Ue.appendChild(s), t = !parseFloat(e.getComputedStyle(n).marginRight), Ue.removeChild(s), a.removeChild(n), t
            }
        }))
    }();
    var Xe = /^(none|table(?!-c[ea]).+)/,
        Ye = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        Ve = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        Ge = ["Webkit", "O", "Moz", "ms"],
        Qe = B.createElement("div").style;
    K.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = S(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o, r, s, a = K.camelCase(t),
                    u = e.style;
                return t = K.cssProps[a] || (K.cssProps[a] = E(a) || a), s = K.cssHooks[t] || K.cssHooks[a], void 0 === n ? s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : u[t] : ("string" === (r = typeof n) && (o = Te.exec(n)) && o[1] && (n = l(e, t, o), r = "number"), void(null != n && n == n && ("number" === r && (n += o && o[3] || (K.cssNumber[a] ? "" : "px")), Z.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, i)) || (u[t] = n))))
            }
        },
        css: function(e, t, n, i) {
            var o, r, s, a = K.camelCase(t);
            return t = K.cssProps[a] || (K.cssProps[a] = E(a) || a), (s = K.cssHooks[t] || K.cssHooks[a]) && "get" in s && (o = s.get(e, !0, n)), void 0 === o && (o = S(e, t, i)), "normal" === o && t in Ve && (o = Ve[t]), "" === n || n ? (r = parseFloat(o), !0 === n || isFinite(r) ? r || 0 : o) : o
        }
    }), K.each(["height", "width"], function(e, t) {
        K.cssHooks[t] = {
            get: function(e, n, i) {
                return n ? Xe.test(K.css(e, "display")) && 0 === e.offsetWidth ? Be(e, Ye, function() {
                    return N(e, t, i)
                }) : N(e, t, i) : void 0
            },
            set: function(e, n, i) {
                var o, r = i && We(e),
                    s = i && j(e, t, i, "border-box" === K.css(e, "boxSizing", !1, r), r);
                return s && (o = Te.exec(n)) && "px" !== (o[3] || "px") && (e.style[t] = n, n = K.css(e, t)), A(0, n, s)
            }
        }
    }), K.cssHooks.marginLeft = $(Z.reliableMarginLeft, function(e, t) {
        return t ? (parseFloat(S(e, "marginLeft")) || e.getBoundingClientRect().left - Be(e, {
            marginLeft: 0
        }, function() {
            return e.getBoundingClientRect().left
        })) + "px" : void 0
    }), K.cssHooks.marginRight = $(Z.reliableMarginRight, function(e, t) {
        return t ? Be(e, {
            display: "inline-block"
        }, S, [e, "marginRight"]) : void 0
    }), K.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        K.cssHooks[e + t] = {
            expand: function(n) {
                for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) o[e + Ce[i] + t] = r[i] || r[i - 2] || r[0];
                return o
            }
        }, Me.test(e) || (K.cssHooks[e + t].set = A)
    }), K.fn.extend({
        css: function(e, t) {
            return ge(this, function(e, t, n) {
                var i, o, r = {},
                    s = 0;
                if (K.isArray(t)) {
                    for (i = We(e), o = t.length; o > s; s++) r[t[s]] = K.css(e, t[s], !1, i);
                    return r
                }
                return void 0 !== n ? K.style(e, t, n) : K.css(e, t)
            }, e, t, arguments.length > 1)
        },
        show: function() {
            return D(this, !0)
        },
        hide: function() {
            return D(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Se(this) ? K(this).show() : K(this).hide()
            })
        }
    }), K.Tween = O, O.prototype = {
        constructor: O,
        init: function(e, t, n, i, o, r) {
            this.elem = e, this.prop = n, this.easing = o || K.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (K.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = O.propHooks[this.prop];
            return e && e.get ? e.get(this) : O.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = O.propHooks[this.prop];
            return this.options.duration ? this.pos = t = K.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : O.propHooks._default.set(this), this
        }
    }, O.prototype.init.prototype = O.prototype, O.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = K.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                K.fx.step[e.prop] ? K.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[K.cssProps[e.prop]] && !K.cssHooks[e.prop] ? e.elem[e.prop] = e.now : K.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }, O.propHooks.scrollTop = O.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, K.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    }, K.fx = O.prototype.init, K.fx.step = {};
    var Je, Ze, Ke = /^(?:toggle|show|hide)$/,
        et = /queueHooks$/;
    K.Animation = K.extend(L, {
            tweeners: {
                "*": [function(e, t) {
                    var n = this.createTween(e, t);
                    return l(n.elem, e, Te.exec(t), n), n
                }]
            },
            tweener: function(e, t) {
                K.isFunction(e) ? (t = e, e = ["*"]) : e = e.match(ve);
                for (var n, i = 0, o = e.length; o > i; i++) n = e[i], L.tweeners[n] = L.tweeners[n] || [], L.tweeners[n].unshift(t)
            },
            prefilters: [function(e, t, n) {
                var i, o, r, s, a, l, u, c = this,
                    d = {},
                    p = e.style,
                    f = e.nodeType && Se(e),
                    h = ye.get(e, "fxshow");
                for (i in n.queue || (null == (a = K._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
                        a.unqueued || l()
                    }), a.unqueued++, c.always(function() {
                        c.always(function() {
                            a.unqueued--, K.queue(e, "fx").length || a.empty.fire()
                        })
                    })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], "inline" === ("none" === (u = K.css(e, "display")) ? ye.get(e, "olddisplay") || C(e.nodeName) : u) && "none" === K.css(e, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", c.always(function() {
                        p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
                    })), t)
                    if (o = t[i], Ke.exec(o)) {
                        if (delete t[i], r = r || "toggle" === o, o === (f ? "hide" : "show")) {
                            if ("show" !== o || !h || void 0 === h[i]) continue;
                            f = !0
                        }
                        d[i] = h && h[i] || K.style(e, i)
                    } else u = void 0;
                if (K.isEmptyObject(d)) "inline" === ("none" === u ? C(e.nodeName) : u) && (p.display = u);
                else
                    for (i in h ? "hidden" in h && (f = h.hidden) : h = ye.access(e, "fxshow", {}), r && (h.hidden = !f), f ? K(e).show() : c.done(function() {
                            K(e).hide()
                        }), c.done(function() {
                            var t;
                            for (t in ye.remove(e, "fxshow"), d) K.style(e, t, d[t])
                        }), d) s = P(f ? h[i] : 0, i, c), i in h || (h[i] = s.start, f && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0))
            }],
            prefilter: function(e, t) {
                t ? L.prefilters.unshift(e) : L.prefilters.push(e)
            }
        }), K.speed = function(e, t, n) {
            var i = e && "object" == typeof e ? K.extend({}, e) : {
                complete: n || !n && t || K.isFunction(e) && e,
                duration: e,
                easing: n && t || t && !K.isFunction(t) && t
            };
            return i.duration = K.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in K.fx.speeds ? K.fx.speeds[i.duration] : K.fx.speeds._default, null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
                K.isFunction(i.old) && i.old.call(this), i.queue && K.dequeue(this, i.queue)
            }, i
        }, K.fn.extend({
            fadeTo: function(e, t, n, i) {
                return this.filter(Se).css("opacity", 0).show().end().animate({
                    opacity: t
                }, e, n, i)
            },
            animate: function(e, t, n, i) {
                var o = K.isEmptyObject(e),
                    r = K.speed(t, n, i),
                    s = function() {
                        var t = L(this, K.extend({}, e), r);
                        (o || ye.get(this, "finish")) && t.stop(!0)
                    };
                return s.finish = s, o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
            },
            stop: function(e, t, n) {
                var i = function(e) {
                    var t = e.stop;
                    delete e.stop, t(n)
                };
                return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function() {
                    var t = !0,
                        o = null != e && e + "queueHooks",
                        r = K.timers,
                        s = ye.get(this);
                    if (o) s[o] && s[o].stop && i(s[o]);
                    else
                        for (o in s) s[o] && s[o].stop && et.test(o) && i(s[o]);
                    for (o = r.length; o--;) r[o].elem !== this || null != e && r[o].queue !== e || (r[o].anim.stop(n), t = !1, r.splice(o, 1));
                    !t && n || K.dequeue(this, e)
                })
            },
            finish: function(e) {
                return !1 !== e && (e = e || "fx"), this.each(function() {
                    var t, n = ye.get(this),
                        i = n[e + "queue"],
                        o = n[e + "queueHooks"],
                        r = K.timers,
                        s = i ? i.length : 0;
                    for (n.finish = !0, K.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--;) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                    for (t = 0; s > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
                    delete n.finish
                })
            }
        }), K.each(["toggle", "show", "hide"], function(e, t) {
            var n = K.fn[t];
            K.fn[t] = function(e, i, o) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(q(t, !0), e, i, o)
            }
        }), K.each({
            slideDown: q("show"),
            slideUp: q("hide"),
            slideToggle: q("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(e, t) {
            K.fn[e] = function(e, n, i) {
                return this.animate(t, e, n, i)
            }
        }), K.timers = [], K.fx.tick = function() {
            var e, t = 0,
                n = K.timers;
            for (Je = K.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || K.fx.stop(), Je = void 0
        }, K.fx.timer = function(e) {
            K.timers.push(e), e() ? K.fx.start() : K.timers.pop()
        }, K.fx.interval = 13, K.fx.start = function() {
            Ze || (Ze = e.setInterval(K.fx.tick, K.fx.interval))
        }, K.fx.stop = function() {
            e.clearInterval(Ze), Ze = null
        }, K.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, K.fn.delay = function(t, n) {
            return t = K.fx && K.fx.speeds[t] || t, n = n || "fx", this.queue(n, function(n, i) {
                var o = e.setTimeout(n, t);
                i.stop = function() {
                    e.clearTimeout(o)
                }
            })
        },
        function() {
            var e = B.createElement("input"),
                t = B.createElement("select"),
                n = t.appendChild(B.createElement("option"));
            e.type = "checkbox", Z.checkOn = "" !== e.value, Z.optSelected = n.selected, t.disabled = !0, Z.optDisabled = !n.disabled, (e = B.createElement("input")).value = "t", e.type = "radio", Z.radioValue = "t" === e.value
        }();
    var tt, nt = K.expr.attrHandle;
    K.fn.extend({
        attr: function(e, t) {
            return ge(this, K.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                K.removeAttr(this, e)
            })
        }
    }), K.extend({
        attr: function(e, t, n) {
            var i, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return void 0 === e.getAttribute ? K.prop(e, t, n) : (1 === r && K.isXMLDoc(e) || (t = t.toLowerCase(), o = K.attrHooks[t] || (K.expr.match.bool.test(t) ? tt : void 0)), void 0 !== n ? null === n ? void K.removeAttr(e, t) : o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : o && "get" in o && null !== (i = o.get(e, t)) ? i : null == (i = K.find.attr(e, t)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!Z.radioValue && "radio" === t && K.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, i, o = 0,
                r = t && t.match(ve);
            if (r && 1 === e.nodeType)
                for (; n = r[o++];) i = K.propFix[n] || n, K.expr.match.bool.test(n) && (e[i] = !1), e.removeAttribute(n)
        }
    }), tt = {
        set: function(e, t, n) {
            return !1 === t ? K.removeAttr(e, n) : e.setAttribute(n, n), n
        }
    }, K.each(K.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = nt[t] || K.find.attr;
        nt[t] = function(e, t, i) {
            var o, r;
            return i || (r = nt[t], nt[t] = o, o = null != n(e, t, i) ? t.toLowerCase() : null, nt[t] = r), o
        }
    });
    var it = /^(?:input|select|textarea|button)$/i,
        ot = /^(?:a|area)$/i;
    K.fn.extend({
        prop: function(e, t) {
            return ge(this, K.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[K.propFix[e] || e]
            })
        }
    }), K.extend({
        prop: function(e, t, n) {
            var i, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && K.isXMLDoc(e) || (t = K.propFix[t] || t, o = K.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = K.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : it.test(e.nodeName) || ot.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), Z.optSelected || (K.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), K.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        K.propFix[this.toLowerCase()] = this
    });
    var rt = /[\t\r\n\f]/g;
    K.fn.extend({
        addClass: function(e) {
            var t, n, i, o, r, s, a, l = 0;
            if (K.isFunction(e)) return this.each(function(t) {
                K(this).addClass(e.call(this, t, _(this)))
            });
            if ("string" == typeof e && e)
                for (t = e.match(ve) || []; n = this[l++];)
                    if (o = _(n), i = 1 === n.nodeType && (" " + o + " ").replace(rt, " ")) {
                        for (s = 0; r = t[s++];) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        o !== (a = K.trim(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(e) {
            var t, n, i, o, r, s, a, l = 0;
            if (K.isFunction(e)) return this.each(function(t) {
                K(this).removeClass(e.call(this, t, _(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof e && e)
                for (t = e.match(ve) || []; n = this[l++];)
                    if (o = _(n), i = 1 === n.nodeType && (" " + o + " ").replace(rt, " ")) {
                        for (s = 0; r = t[s++];)
                            for (; i.indexOf(" " + r + " ") > -1;) i = i.replace(" " + r + " ", " ");
                        o !== (a = K.trim(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : K.isFunction(e) ? this.each(function(n) {
                K(this).toggleClass(e.call(this, n, _(this), t), t)
            }) : this.each(function() {
                var t, i, o, r;
                if ("string" === n)
                    for (i = 0, o = K(this), r = e.match(ve) || []; t = r[i++];) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                else void 0 !== e && "boolean" !== n || ((t = _(this)) && ye.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : ye.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, i = 0;
            for (t = " " + e + " "; n = this[i++];)
                if (1 === n.nodeType && (" " + _(n) + " ").replace(rt, " ").indexOf(t) > -1) return !0;
            return !1
        }
    });
    var st = /\r/g,
        at = /[\x20\t\r\n\f]+/g;
    K.fn.extend({
        val: function(e) {
            var t, n, i, o = this[0];
            return arguments.length ? (i = K.isFunction(e), this.each(function(n) {
                var o;
                1 === this.nodeType && (null == (o = i ? e.call(this, n, K(this).val()) : e) ? o = "" : "number" == typeof o ? o += "" : K.isArray(o) && (o = K.map(o, function(e) {
                    return null == e ? "" : e + ""
                })), (t = K.valHooks[this.type] || K.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o))
            })) : o ? (t = K.valHooks[o.type] || K.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : "string" == typeof(n = o.value) ? n.replace(st, "") : null == n ? "" : n : void 0
        }
    }), K.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = K.find.attr(e, "value");
                    return null != t ? t : K.trim(K.text(e)).replace(at, " ")
                }
            },
            select: {
                get: function(e) {
                    for (var t, n, i = e.options, o = e.selectedIndex, r = "select-one" === e.type || 0 > o, s = r ? null : [], a = r ? o + 1 : i.length, l = 0 > o ? a : r ? o : 0; a > l; l++)
                        if (((n = i[l]).selected || l === o) && (Z.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !K.nodeName(n.parentNode, "optgroup"))) {
                            if (t = K(n).val(), r) return t;
                            s.push(t)
                        }
                    return s
                },
                set: function(e, t) {
                    for (var n, i, o = e.options, r = K.makeArray(t), s = o.length; s--;)((i = o[s]).selected = K.inArray(K.valHooks.option.get(i), r) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1), r
                }
            }
        }
    }), K.each(["radio", "checkbox"], function() {
        K.valHooks[this] = {
            set: function(e, t) {
                return K.isArray(t) ? e.checked = K.inArray(K(e).val(), t) > -1 : void 0
            }
        }, Z.checkOn || (K.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    });
    var lt = /^(?:focusinfocus|focusoutblur)$/;
    K.extend(K.event, {
        trigger: function(t, n, i, o) {
            var r, s, a, l, u, c, d, p = [i || B],
                f = J.call(t, "type") ? t.type : t,
                h = J.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = a = i = i || B, 3 !== i.nodeType && 8 !== i.nodeType && !lt.test(f + K.event.triggered) && (f.indexOf(".") > -1 && (h = f.split("."), f = h.shift(), h.sort()), u = f.indexOf(":") < 0 && "on" + f, (t = t[K.expando] ? t : new K.Event(f, "object" == typeof t && t)).isTrigger = o ? 2 : 3, t.namespace = h.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : K.makeArray(n, [t]), d = K.event.special[f] || {}, o || !d.trigger || !1 !== d.trigger.apply(i, n))) {
                if (!o && !d.noBubble && !K.isWindow(i)) {
                    for (l = d.delegateType || f, lt.test(l + f) || (s = s.parentNode); s; s = s.parentNode) p.push(s), a = s;
                    a === (i.ownerDocument || B) && p.push(a.defaultView || a.parentWindow || e)
                }
                for (r = 0;
                    (s = p[r++]) && !t.isPropagationStopped();) t.type = r > 1 ? l : d.bindType || f, (c = (ye.get(s, "events") || {})[t.type] && ye.get(s, "handle")) && c.apply(s, n), (c = u && s[u]) && c.apply && me(s) && (t.result = c.apply(s, n), !1 === t.result && t.preventDefault());
                return t.type = f, o || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(p.pop(), n) || !me(i) || u && K.isFunction(i[f]) && !K.isWindow(i) && ((a = i[u]) && (i[u] = null), K.event.triggered = f, i[f](), K.event.triggered = void 0, a && (i[u] = a)), t.result
            }
        },
        simulate: function(e, t, n) {
            var i = K.extend(new K.Event, n, {
                type: e,
                isSimulated: !0
            });
            K.event.trigger(i, null, t), i.isDefaultPrevented() && n.preventDefault()
        }
    }), K.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                K.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            return n ? K.event.trigger(e, t, n, !0) : void 0
        }
    }), K.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
        K.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }), K.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }), Z.focusin = "onfocusin" in e, Z.focusin || K.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            K.event.simulate(t, e.target, K.event.fix(e))
        };
        K.event.special[t] = {
            setup: function() {
                var i = this.ownerDocument || this,
                    o = ye.access(i, t);
                o || i.addEventListener(e, n, !0), ye.access(i, t, (o || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this,
                    o = ye.access(i, t) - 1;
                o ? ye.access(i, t, o) : (i.removeEventListener(e, n, !0), ye.remove(i, t))
            }
        }
    });
    var ut = e.location,
        ct = K.now(),
        dt = /\?/;
    K.parseJSON = function(e) {
        return JSON.parse(e + "")
    }, K.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || K.error("Invalid XML: " + t), n
    };
    var pt = /#.*$/,
        ft = /([?&])_=[^&]*/,
        ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        vt = /^(?:GET|HEAD)$/,
        gt = /^\/\//,
        mt = {},
        yt = {},
        wt = "*/".concat("*"),
        bt = B.createElement("a");
    bt.href = ut.href, K.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ut.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ut.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": wt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": K.parseJSON,
                "text xml": K.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? F(F(e, K.ajaxSettings), t) : F(K.ajaxSettings, e)
        },
        ajaxPrefilter: z(mt),
        ajaxTransport: z(yt),
        ajax: function(t, n) {
            function i(t, n, i, a) {
                var u, d, y, w, x, T = n;
                2 !== b && (b = 2, l && e.clearTimeout(l), o = void 0, s = a || "", k.readyState = t > 0 ? 4 : 0, u = t >= 200 && 300 > t || 304 === t, i && (w = function(e, t, n) {
                    for (var i, o, r, s, a = e.contents, l = e.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (i)
                        for (o in a)
                            if (a[o] && a[o].test(i)) {
                                l.unshift(o);
                                break
                            }
                    if (l[0] in n) r = l[0];
                    else {
                        for (o in n) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                r = o;
                                break
                            }
                            s || (s = o)
                        }
                        r = r || s
                    }
                    return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0
                }(p, k, i)), w = function(e, t, n, i) {
                    var o, r, s, a, l, u = {},
                        c = e.dataTypes.slice();
                    if (c[1])
                        for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
                    for (r = c.shift(); r;)
                        if (e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = c.shift())
                            if ("*" === r) r = l;
                            else if ("*" !== l && l !== r) {
                        if (!(s = u[l + " " + r] || u["* " + r]))
                            for (o in u)
                                if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                    !0 === s ? s = u[o] : !0 !== u[o] && (r = a[0], c.unshift(a[1]));
                                    break
                                }
                        if (!0 !== s)
                            if (s && e.throws) t = s(t);
                            else try {
                                t = s(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: s ? e : "No conversion from " + l + " to " + r
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(p, w, k, u), u ? (p.ifModified && ((x = k.getResponseHeader("Last-Modified")) && (K.lastModified[r] = x), (x = k.getResponseHeader("etag")) && (K.etag[r] = x)), 204 === t || "HEAD" === p.type ? T = "nocontent" : 304 === t ? T = "notmodified" : (T = w.state, d = w.data, u = !(y = w.error))) : (y = T, !t && T || (T = "error", 0 > t && (t = 0))), k.status = t, k.statusText = (n || T) + "", u ? v.resolveWith(f, [d, T, k]) : v.rejectWith(f, [k, T, y]), k.statusCode(m), m = void 0, c && h.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? d : y]), g.fireWith(f, [k, T]), c && (h.trigger("ajaxComplete", [k, p]), --K.active || K.event.trigger("ajaxStop")))
            }
            "object" == typeof t && (n = t, t = void 0), n = n || {};
            var o, r, s, a, l, u, c, d, p = K.ajaxSetup({}, n),
                f = p.context || p,
                h = p.context && (f.nodeType || f.jquery) ? K(f) : K.event,
                v = K.Deferred(),
                g = K.Callbacks("once memory"),
                m = p.statusCode || {},
                y = {},
                w = {},
                b = 0,
                x = "canceled",
                k = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (2 === b) {
                            if (!a)
                                for (a = {}; t = ht.exec(s);) a[t[1].toLowerCase()] = t[2];
                            t = a[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function() {
                        return 2 === b ? s : null
                    },
                    setRequestHeader: function(e, t) {
                        var n = e.toLowerCase();
                        return b || (e = w[n] = w[n] || e, y[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return b || (p.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (2 > b)
                                for (t in e) m[t] = [m[t], e[t]];
                            else k.always(e[k.status]);
                        return this
                    },
                    abort: function(e) {
                        var t = e || x;
                        return o && o.abort(t), i(0, t), this
                    }
                };
            if (v.promise(k).complete = g.add, k.success = k.done, k.error = k.fail, p.url = ((t || p.url || ut.href) + "").replace(pt, "").replace(gt, ut.protocol + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = K.trim(p.dataType || "*").toLowerCase().match(ve) || [""], null == p.crossDomain) {
                u = B.createElement("a");
                try {
                    u.href = p.url, u.href = u.href, p.crossDomain = bt.protocol + "//" + bt.host != u.protocol + "//" + u.host
                } catch (e) {
                    p.crossDomain = !0
                }
            }
            if (p.data && p.processData && "string" != typeof p.data && (p.data = K.param(p.data, p.traditional)), I(mt, p, n, k), 2 === b) return k;
            for (d in (c = K.event && p.global) && 0 == K.active++ && K.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !vt.test(p.type), r = p.url, p.hasContent || (p.data && (r = p.url += (dt.test(r) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (p.url = ft.test(r) ? r.replace(ft, "$1_=" + ct++) : r + (dt.test(r) ? "&" : "?") + "_=" + ct++)), p.ifModified && (K.lastModified[r] && k.setRequestHeader("If-Modified-Since", K.lastModified[r]), K.etag[r] && k.setRequestHeader("If-None-Match", K.etag[r])), (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && k.setRequestHeader("Content-Type", p.contentType), k.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + wt + "; q=0.01" : "") : p.accepts["*"]), p.headers) k.setRequestHeader(d, p.headers[d]);
            if (p.beforeSend && (!1 === p.beforeSend.call(f, k, p) || 2 === b)) return k.abort();
            for (d in x = "abort", {
                    success: 1,
                    error: 1,
                    complete: 1
                }) k[d](p[d]);
            if (o = I(yt, p, n, k)) {
                if (k.readyState = 1, c && h.trigger("ajaxSend", [k, p]), 2 === b) return k;
                p.async && p.timeout > 0 && (l = e.setTimeout(function() {
                    k.abort("timeout")
                }, p.timeout));
                try {
                    b = 1, o.send(y, i)
                } catch (e) {
                    if (!(2 > b)) throw e;
                    i(-1, e)
                }
            } else i(-1, "No Transport");
            return k
        },
        getJSON: function(e, t, n) {
            return K.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return K.get(e, void 0, t, "script")
        }
    }), K.each(["get", "post"], function(e, t) {
        K[t] = function(e, n, i, o) {
            return K.isFunction(n) && (o = o || i, i = n, n = void 0), K.ajax(K.extend({
                url: e,
                type: t,
                dataType: o,
                data: n,
                success: i
            }, K.isPlainObject(e) && e))
        }
    }), K._evalUrl = function(e) {
        return K.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }, K.fn.extend({
        wrapAll: function(e) {
            var t;
            return K.isFunction(e) ? this.each(function(t) {
                K(this).wrapAll(e.call(this, t))
            }) : (this[0] && (t = K(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this)
        },
        wrapInner: function(e) {
            return K.isFunction(e) ? this.each(function(t) {
                K(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = K(this),
                    n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = K.isFunction(e);
            return this.each(function(n) {
                K(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                K.nodeName(this, "body") || K(this).replaceWith(this.childNodes)
            }).end()
        }
    }), K.expr.filters.hidden = function(e) {
        return !K.expr.filters.visible(e)
    }, K.expr.filters.visible = function(e) {
        return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0
    };
    var xt = /%20/g,
        kt = /\[\]$/,
        Tt = /\r?\n/g,
        Ct = /^(?:submit|button|image|reset|file)$/i,
        St = /^(?:input|select|textarea|keygen)/i;
    K.param = function(e, t) {
        var n, i = [],
            o = function(e, t) {
                t = K.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
            };
        if (void 0 === t && (t = K.ajaxSettings && K.ajaxSettings.traditional), K.isArray(e) || e.jquery && !K.isPlainObject(e)) K.each(e, function() {
            o(this.name, this.value)
        });
        else
            for (n in e) M(n, e[n], t, o);
        return i.join("&").replace(xt, "+")
    }, K.fn.extend({
        serialize: function() {
            return K.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = K.prop(this, "elements");
                return e ? K.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !K(this).is(":disabled") && St.test(this.nodeName) && !Ct.test(e) && (this.checked || !$e.test(e))
            }).map(function(e, t) {
                var n = K(this).val();
                return null == n ? null : K.isArray(n) ? K.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Tt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Tt, "\r\n")
                }
            }).get()
        }
    }), K.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    };
    var $t = {
            0: 200,
            1223: 204
        },
        Et = K.ajaxSettings.xhr();
    Z.cors = !!Et && "withCredentials" in Et, Z.ajax = Et = !!Et, K.ajaxTransport(function(t) {
        var n, i;
        return Z.cors || Et && !t.crossDomain ? {
            send: function(o, r) {
                var s, a = t.xhr();
                if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                    for (s in t.xhrFields) a[s] = t.xhrFields[s];
                for (s in t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o) a.setRequestHeader(s, o[s]);
                n = function(e) {
                    return function() {
                        n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? r(0, "error") : r(a.status, a.statusText) : r($t[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = n(), i = a.onerror = n("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                    4 === a.readyState && e.setTimeout(function() {
                        n && i()
                    })
                }, n = n("abort");
                try {
                    a.send(t.hasContent && t.data || null)
                } catch (e) {
                    if (n) throw e
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }), K.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return K.globalEval(e), e
            }
        }
    }), K.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), K.ajaxTransport("script", function(e) {
        var t, n;
        if (e.crossDomain) return {
            send: function(i, o) {
                t = K("<script>").prop({
                    charset: e.scriptCharset,
                    src: e.url
                }).on("load error", n = function(e) {
                    t.remove(), n = null, e && o("error" === e.type ? 404 : 200, e.type)
                }), B.head.appendChild(t[0])
            },
            abort: function() {
                n && n()
            }
        }
    });
    var At = [],
        jt = /(=)\?(?=&|$)|\?\?/;
    K.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = At.pop() || K.expando + "_" + ct++;
            return this[e] = !0, e
        }
    }), K.ajaxPrefilter("json jsonp", function(t, n, i) {
        var o, r, s, a = !1 !== t.jsonp && (jt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && jt.test(t.data) && "data");
        return a || "jsonp" === t.dataTypes[0] ? (o = t.jsonpCallback = K.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(jt, "$1" + o) : !1 !== t.jsonp && (t.url += (dt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function() {
            return s || K.error(o + " was not called"), s[0]
        }, t.dataTypes[0] = "json", r = e[o], e[o] = function() {
            s = arguments
        }, i.always(function() {
            void 0 === r ? K(e).removeProp(o) : e[o] = r, t[o] && (t.jsonpCallback = n.jsonpCallback, At.push(o)), s && K.isFunction(r) && r(s[0]), s = r = void 0
        }), "script") : void 0
    }), K.parseHTML = function(e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || B;
        var i = le.exec(e),
            o = !n && [];
        return i ? [t.createElement(i[1])] : (i = d([e], t, o), o && o.length && K(o).remove(), K.merge([], i.childNodes))
    };
    var Nt = K.fn.load;
    K.fn.load = function(e, t, n) {
        if ("string" != typeof e && Nt) return Nt.apply(this, arguments);
        var i, o, r, s = this,
            a = e.indexOf(" ");
        return a > -1 && (i = K.trim(e.slice(a)), e = e.slice(0, a)), K.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (o = "POST"), s.length > 0 && K.ajax({
            url: e,
            type: o || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, s.html(i ? K("<div>").append(K.parseHTML(e)).find(i) : e)
        }).always(n && function(e, t) {
            s.each(function() {
                n.apply(this, r || [e.responseText, t, e])
            })
        }), this
    }, K.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        K.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), K.expr.filters.animated = function(e) {
        return K.grep(K.timers, function(t) {
            return e === t.elem
        }).length
    }, K.offset = {
        setOffset: function(e, t, n) {
            var i, o, r, s, a, l, u = K.css(e, "position"),
                c = K(e),
                d = {};
            "static" === u && (e.style.position = "relative"), a = c.offset(), r = K.css(e, "top"), l = K.css(e, "left"), ("absolute" === u || "fixed" === u) && (r + l).indexOf("auto") > -1 ? (s = (i = c.position()).top, o = i.left) : (s = parseFloat(r) || 0, o = parseFloat(l) || 0), K.isFunction(t) && (t = t.call(e, n, K.extend({}, a))), null != t.top && (d.top = t.top - a.top + s), null != t.left && (d.left = t.left - a.left + o), "using" in t ? t.using.call(e, d) : c.css(d)
        }
    }, K.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                K.offset.setOffset(this, e, t)
            });
            var t, n, i = this[0],
                o = {
                    top: 0,
                    left: 0
                },
                r = i && i.ownerDocument;
            return r ? (t = r.documentElement, K.contains(t, i) ? (o = i.getBoundingClientRect(), n = R(r), {
                top: o.top + n.pageYOffset - t.clientTop,
                left: o.left + n.pageXOffset - t.clientLeft
            }) : o) : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n = this[0],
                    i = {
                        top: 0,
                        left: 0
                    };
                return "fixed" === K.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), K.nodeName(e[0], "html") || (i = e.offset()), i.top += K.css(e[0], "borderTopWidth", !0), i.left += K.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - i.top - K.css(n, "marginTop", !0),
                    left: t.left - i.left - K.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === K.css(e, "position");) e = e.offsetParent;
                return e || Ue
            })
        }
    }), K.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var n = "pageYOffset" === t;
        K.fn[e] = function(i) {
            return ge(this, function(e, i, o) {
                var r = R(e);
                return void 0 === o ? r ? r[t] : e[i] : void(r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : e[i] = o)
            }, e, i, arguments.length)
        }
    }), K.each(["top", "left"], function(e, t) {
        K.cssHooks[t] = $(Z.pixelPosition, function(e, n) {
            return n ? (n = S(e, t), Re.test(n) ? K(e).position()[t] + "px" : n) : void 0
        })
    }), K.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        K.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, i) {
            K.fn[i] = function(i, o) {
                var r = arguments.length && (n || "boolean" != typeof i),
                    s = n || (!0 === i || !0 === o ? "margin" : "border");
                return ge(this, function(t, n, i) {
                    var o;
                    return K.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? K.css(t, n, s) : K.style(t, n, i, s)
                }, t, r ? i : void 0, r, null)
            }
        })
    }), K.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        },
        size: function() {
            return this.length
        }
    }), K.fn.andSelf = K.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return K
    });
    var Dt = e.jQuery,
        Ot = e.$;
    return K.noConflict = function(t) {
        return e.$ === K && (e.$ = Ot), t && e.jQuery === K && (e.jQuery = Dt), K
    }, t || (e.jQuery = e.$ = K), K
}),
function(e) {
    var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    e.zoom = function(t, n, i, o) {
        var r, s, a, l, u, c, d, p = e(t),
            f = p.css("position"),
            h = e(n);
        return p.css("position", /(absolute|fixed)/.test(f) ? f : "relative"), p.css("overflow", "hidden"), i.style.width = i.style.height = "", e(i).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * o,
            height: i.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(t), {
            init: function() {
                s = p.outerWidth(), r = p.outerHeight(), n === p[0] ? (l = s, a = r) : (l = h.outerWidth(), a = h.outerHeight()), u = (i.width - s) / l, c = (i.height - r) / a, d = h.offset()
            },
            move: function(e) {
                var t = e.pageX - d.left,
                    n = e.pageY - d.top;
                n = Math.max(Math.min(n, a), 0), t = Math.max(Math.min(t, l), 0), i.style.left = t * -u + "px", i.style.top = n * -c + "px"
            }
        }
    }, e.fn.zoom = function(n) {
        return this.each(function() {
            var i, o = e.extend({}, t, n || {}),
                r = o.target || this,
                s = this,
                a = e(s),
                l = e(r),
                u = document.createElement("img"),
                c = e(u),
                d = "mousemove.zoom",
                p = !1,
                f = !1;
            (o.url || ((i = a.find("img"))[0] && (o.url = i.data("src") || i.attr("src")), o.url)) && (function() {
                var e = l.css("position"),
                    t = l.css("overflow");
                a.one("zoom.destroy", function() {
                    a.off(".zoom"), l.css("position", e), l.css("overflow", t), c.remove()
                })
            }(), u.onload = function() {
                function t(t) {
                    i.init(), i.move(t), c.stop().fadeTo(e.support.opacity ? o.duration : 0, 1, !!e.isFunction(o.onZoomIn) && o.onZoomIn.call(u))
                }

                function n() {
                    c.stop().fadeTo(o.duration, 0, !!e.isFunction(o.onZoomOut) && o.onZoomOut.call(u))
                }
                var i = e.zoom(r, s, u, o.magnify);
                "grab" === o.on ? a.on("mousedown.zoom", function(o) {
                    1 === o.which && (e(document).one("mouseup.zoom", function() {
                        n(), e(document).off(d, i.move)
                    }), t(o), e(document).on(d, i.move), o.preventDefault())
                }) : "click" === o.on ? a.on("click.zoom", function(o) {
                    return p ? void 0 : (p = !0, t(o), e(document).on(d, i.move), e(document).one("click.zoom", function() {
                        n(), p = !1, e(document).off(d, i.move)
                    }), !1)
                }) : "toggle" === o.on ? a.on("click.zoom", function(e) {
                    p ? n() : t(e), p = !p
                }) : "mouseover" === o.on && (i.init(), a.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(d, i.move)), o.touch && a.on("touchstart.zoom", function(e) {
                    e.preventDefault(), f ? (f = !1, n()) : (f = !0, t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(e) {
                    e.preventDefault(), i.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(e) {
                    e.preventDefault(), f && (f = !1, n())
                }), e.isFunction(o.callback) && o.callback.call(u)
            }, u.src = o.url)
        })
    }, e.fn.zoom.defaults = t
}(window.jQuery),
function() {
    function e(e, t) {
        for (var n = -1, i = t.length, o = e.length; ++n < i;) e[o + n] = t[n];
        return e
    }

    function t(e, t, n) {
        for (var i = -1, o = e.length; ++i < o;) {
            var r = e[i],
                s = t(r);
            if (null != s && (a === J ? s == s : n(s, a))) var a = s,
                l = r
        }
        return l
    }

    function n(e) {
        return e && e.Object === Object ? e : null
    }

    function i(e) {
        return te[e]
    }

    function o(e) {
        var t = !1;
        if (null != e && "function" != typeof e.toString) try {
            t = !!(e + "")
        } catch (e) {}
        return t
    }

    function r(e, t) {
        return (e = "number" == typeof e || ee.test(e) ? +e : -1) > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
    }

    function s(e) {
        if (M(e) && !Ne(e)) {
            if (e instanceof a) return e;
            if (pe.call(e, "__wrapped__")) {
                var t = new a(e.__wrapped__, e.__chain__);
                return t.__actions__ = k(e.__actions__), t
            }
        }
        return new a(e)
    }

    function a(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t
    }

    function l(e, t, n, i) {
        var o;
        return (o = e === J) || (o = (e === (o = de[n]) || e != e && o != o) && !pe.call(i, n)), o ? t : e
    }

    function u(e) {
        return F(e) ? ye(e) : {}
    }

    function c(e, t, n) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return setTimeout(function() {
            e.apply(J, n)
        }, t)
    }

    function d(e, t) {
        var n = [];
        return Te(e, function(e, i, o) {
            t(e, i, o) && n.push(e)
        }), n
    }

    function p(t, n, i, o) {
        o || (o = []);
        for (var r = -1, s = t.length; ++r < s;) {
            var a = t[r];
            n > 0 && M(a) && _(a) && (i || Ne(a) || L(a)) ? n > 1 ? p(a, n - 1, i, o) : e(o, a) : i || (o[o.length] = a)
        }
        return o
    }

    function f(e, t) {
        return e && Ce(e, t, X)
    }

    function h(e, t) {
        return d(t, function(t) {
            return z(e[t])
        })
    }

    function v(e, t, n, i, r) {
        return e === t || (null == e || null == t || !F(e) && !M(t) ? e != e && t != t : function(e, t, n, i, r, s) {
            var a = Ne(e),
                l = Ne(t),
                u = "[object Array]",
                c = "[object Array]";
            a || "[object Arguments]" == (u = he.call(e)) && (u = "[object Object]"), l || "[object Arguments]" == (c = he.call(t)) && (c = "[object Object]");
            var d = "[object Object]" == u && !o(e),
                l = "[object Object]" == c && !o(t);
            return !(c = u == c) || a || d ? 2 & r || (u = d && pe.call(e, "__wrapped__"), l = l && pe.call(t, "__wrapped__"), !u && !l) ? !!c && (s || (s = []), (u = N(s, function(t) {
                return t[0] === e
            })) && u[1] ? u[1] == t : (s.push([e, t]), t = (a ? function(e, t, n, i, o, r) {
                var s = -1,
                    a = 1 & o,
                    l = e.length,
                    u = t.length;
                if (l != u && !(2 & o && u > l)) return !1;
                for (u = !0; ++s < l;) {
                    var c = e[s],
                        d = t[s];
                    if (void 0 !== J) {
                        u = !1;
                        break
                    }
                    if (a) {
                        if (!T(t, function(e) {
                                return c === e || n(c, e, i, o, r)
                            })) {
                            u = !1;
                            break
                        }
                    } else if (c !== d && !n(c, d, i, o, r)) {
                        u = !1;
                        break
                    }
                }
                return u
            } : function(e, t, n, i, o, r) {
                var s = 2 & o,
                    a = X(e),
                    l = a.length,
                    u = X(t).length;
                if (l != u && !s) return !1;
                for (var c = l; c--;) {
                    var d = a[c];
                    if (!(s ? d in t : pe.call(t, d))) return !1
                }
                for (u = !0; ++c < l;) {
                    var d = a[c],
                        p = e[d],
                        f = t[d];
                    if (void 0 !== J || p !== f && !n(p, f, i, o, r)) {
                        u = !1;
                        break
                    }
                    s || (s = "constructor" == d)
                }
                return u && !s && (n = e.constructor, i = t.constructor, n != i && "constructor" in e && "constructor" in t && !("function" == typeof n && n instanceof n && "function" == typeof i && i instanceof i) && (u = !1)), u
            })(e, t, n, i, r, s), s.pop(), t)) : n(u ? e.value() : e, l ? t.value() : t, i, r, s) : function(e, t, n) {
                switch (n) {
                    case "[object Boolean]":
                    case "[object Date]":
                        return +e == +t;
                    case "[object Error]":
                        return e.name == t.name && e.message == t.message;
                    case "[object Number]":
                        return e != +e ? t != +t : e == +t;
                    case "[object RegExp]":
                    case "[object String]":
                        return e == t + ""
                }
                return !1
            }(e, t, u)
        }(e, t, v, n, i, r))
    }

    function g(e) {
        var t = typeof e;
        return "function" == t ? e : null == e ? G : ("object" == t ? w : b)(e)
    }

    function m(e) {
        e = null == e ? e : Object(e);
        var t, n = [];
        for (t in e) n.push(t);
        return n
    }

    function y(e, t) {
        var n = -1,
            i = _(e) ? Array(e.length) : [];
        return Te(e, function(e, o, r) {
            i[++n] = t(e, o, r)
        }), i
    }

    function w(e) {
        var t = X(e);
        return function(n) {
            var i = t.length;
            if (null == n) return !i;
            for (n = Object(n); i--;) {
                var o = t[i];
                if (!(o in n && v(e[o], n[o], J, 3))) return !1
            }
            return !0
        }
    }

    function b(e) {
        return function(t) {
            return null == t ? J : t[e]
        }
    }

    function x(e, t, n) {
        var i = -1,
            o = e.length;
        for (0 > t && (t = -t > o ? 0 : o + t), 0 > (n = n > o ? o : n) && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0, n = Array(o); ++i < o;) n[i] = e[i + t];
        return n
    }

    function k(e) {
        return x(e, 0, e.length)
    }

    function T(e, t) {
        var n;
        return Te(e, function(e, i, o) {
            return !(n = t(e, i, o))
        }), !!n
    }

    function C(e, t, n, i) {
        n || (n = {});
        for (var o = -1, r = t.length; ++o < r;) {
            var s = t[o],
                a = i ? i(n[s], e[s], s, n, e) : e[s],
                l = n,
                u = l[s];
            pe.call(l, s) && (u === a || u != u && a != a) && (a !== J || s in l) || (l[s] = a)
        }
        return n
    }

    function S(e) {
        return q(function(t, n) {
            var i = -1,
                o = n.length,
                r = "function" == typeof(r = o > 1 ? n[o - 1] : J) ? (o--, r) : J;
            for (t = Object(t); ++i < o;) {
                var s = n[i];
                s && e(t, s, i, r)
            }
            return t
        })
    }

    function $(e, t, n) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        var i = function(e) {
            return function() {
                var t = arguments,
                    n = u(e.prototype);
                return F(t = e.apply(n, t)) ? t : n
            }
        }(e);
        return function o() {
            for (var r = -1, s = arguments.length, a = -1, l = n.length, u = Array(l + s), c = this && this !== ue && this instanceof o ? i : e; ++a < l;) u[a] = n[a];
            for (; s--;) u[a++] = arguments[++r];
            return c.apply(t, u)
        }
    }

    function E(e) {
        var t = e ? e.length : J;
        if (I(t) && (Ne(e) || W(e) || L(e))) {
            e = String;
            for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
            t = i
        } else t = null;
        return t
    }

    function A(e) {
        var t;
        return e === (t = z(t = e && e.constructor) && t.prototype || de)
    }

    function j(e) {
        return e ? e[0] : J
    }

    function N(e, t) {
        return function(e, t, n) {
            var i;
            return n(e, function(e, n, o) {
                return t(e, n, o) ? (i = e, !1) : void 0
            }), i
        }(e, g(t), Te)
    }

    function D(e, t) {
        return Te(e, "function" == typeof t ? t : G)
    }

    function O(e, t, n) {
        return function(e, t, n, i, o) {
            return o(e, function(e, o, r) {
                n = i ? (i = !1, e) : t(n, e, o, r)
            }), n
        }(e, g(t), n, 3 > arguments.length, Te)
    }

    function H(e, t) {
        var n;
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return e = De(e),
            function() {
                return 0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = J), n
            }
    }

    function q(e) {
        var t;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return t = ke(t === J ? e.length - 1 : De(t), 0),
            function() {
                for (var n = arguments, i = -1, o = ke(n.length - t, 0), r = Array(o); ++i < o;) r[i] = n[t + i];
                for (o = Array(t + 1), i = -1; ++i < t;) o[i] = n[i];
                return o[t] = r, e.apply(this, o)
            }
    }

    function P(e, t) {
        return e > t
    }

    function L(e) {
        return M(e) && _(e) && pe.call(e, "callee") && (!we.call(e, "callee") || "[object Arguments]" == he.call(e))
    }

    function _(e) {
        return null != e && !("function" == typeof e && z(e)) && I(Se(e))
    }

    function z(e) {
        return "[object Function]" == (e = F(e) ? he.call(e) : "") || "[object GeneratorFunction]" == e
    }

    function I(e) {
        return "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
    }

    function F(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t)
    }

    function M(e) {
        return !!e && "object" == typeof e
    }

    function R(e) {
        return "number" == typeof e || M(e) && "[object Number]" == he.call(e)
    }

    function W(e) {
        return "string" == typeof e || !Ne(e) && M(e) && "[object String]" == he.call(e)
    }

    function B(e, t) {
        return t > e
    }

    function U(e) {
        return "string" == typeof e ? e : null == e ? "" : e + ""
    }

    function X(e) {
        var t = A(e);
        if (!t && !_(e)) return xe(Object(e));
        var n, i, o = !!(i = E(e)),
            s = (i = i || []).length;
        for (n in e) !pe.call(e, n) || o && ("length" == n || r(n, s)) || t && "constructor" == n || i.push(n);
        return i
    }

    function Y(e) {
        for (var t, n = -1, i = A(e), o = m(e), s = o.length, a = !!(t = E(e)), l = (t = t || []).length; ++n < s;) {
            var u = o[n];
            a && ("length" == u || r(u, l)) || "constructor" == u && (i || !pe.call(e, u)) || t.push(u)
        }
        return t
    }

    function V(e) {
        return e ? function(e, t) {
            return y(t, function(t) {
                return e[t]
            })
        }(e, X(e)) : []
    }

    function G(e) {
        return e
    }

    function Q(t, n, i) {
        var o = X(n),
            r = h(n, o);
        null != i || F(n) && (r.length || !o.length) || (i = n, n = t, t = this, r = h(n, X(n)));
        var s = !(F(i) && "chain" in i) || i.chain,
            a = z(t);
        return Te(r, function(i) {
            var o = n[i];
            t[i] = o, a && (t.prototype[i] = function() {
                var n = this.__chain__;
                if (s || n) {
                    var i = t(this.__wrapped__);
                    return (i.__actions__ = k(this.__actions__)).push({
                        func: o,
                        args: arguments,
                        thisArg: t
                    }), i.__chain__ = n, i
                }
                return o.apply(t, e([this.value()], arguments))
            })
        }), t
    }
    var J, Z = /[&<>"'`]/g,
        K = RegExp(Z.source),
        ee = /^(?:0|[1-9]\d*)$/,
        te = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "`": "&#96;"
        },
        ne = {
            function: !0,
            object: !0
        },
        ie = ne[typeof exports] && exports && !exports.nodeType ? exports : J,
        oe = ne[typeof module] && module && !module.nodeType ? module : J,
        re = oe && oe.exports === ie ? ie : J,
        se = n(ne[typeof self] && self),
        ae = n(ne[typeof window] && window),
        le = n(ne[typeof this] && this),
        ue = n(ie && oe && "object" == typeof global && global) || ae !== (le && le.window) && ae || se || le || Function("return this")(),
        ce = Array.prototype,
        de = Object.prototype,
        pe = de.hasOwnProperty,
        fe = 0,
        he = de.toString,
        ve = ue._,
        ge = ue.Reflect,
        me = ge ? ge.f : J,
        ye = Object.create,
        we = de.propertyIsEnumerable,
        be = ue.isFinite,
        xe = Object.keys,
        ke = Math.max,
        Te = function(e, t) {
            return function(t, n) {
                if (null == t) return t;
                if (!_(t)) return e(t, n);
                for (var i = t.length, o = -1, r = Object(t); ++o < i && !1 !== n(r[o], o, r););
                return t
            }
        }(f),
        Ce = function(e, t, n) {
            for (var i = -1, o = Object(e), r = (n = n(e)).length; r--;) {
                var s = n[++i];
                if (!1 === t(o[s], s, o)) break
            }
            return e
        };
    me && !we.call({
        valueOf: 1
    }, "valueOf") && (m = function(e) {
        e = me(e);
        for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
        return n
    });
    var Se = b("length"),
        $e = q(function(t, n) {
            return Ne(t) || (t = null == t ? [] : [Object(t)]), p(n, 1), e(k(t), V)
        }),
        Ee = q(function(e, t, n) {
            return $(e, t, n)
        }),
        Ae = q(function(e, t) {
            return c(e, 1, t)
        }),
        je = q(function(e, t, n) {
            return c(e, Oe(t) || 0, n)
        }),
        Ne = Array.isArray,
        De = Number,
        Oe = Number,
        He = S(function(e, t) {
            C(t, X(t), e)
        }),
        qe = S(function(e, t) {
            C(t, Y(t), e)
        }),
        Pe = S(function(e, t, n, i) {
            C(t, Y(t), e, i)
        }),
        Le = q(function(e) {
            return e.push(J, l), Pe.apply(J, e)
        }),
        _e = q(function(e, t) {
            return null == e ? {} : function(e, t) {
                return e = Object(e), O(t, function(t, n) {
                    return n in e && (t[n] = e[n]), t
                }, {})
            }(e, p(t, 1))
        }),
        ze = g;
    a.prototype = u(s.prototype), a.prototype.constructor = a, s.assignIn = qe, s.before = H, s.bind = Ee, s.chain = function(e) {
        return (e = s(e)).__chain__ = !0, e
    }, s.compact = function(e) {
        return d(e, Boolean)
    }, s.concat = $e, s.create = function(e, t) {
        var n = u(e);
        return t ? He(n, t) : n
    }, s.defaults = Le, s.defer = Ae, s.delay = je, s.filter = function(e, t) {
        return d(e, g(t))
    }, s.flatten = function(e) {
        return e && e.length ? p(e, 1) : []
    }, s.flattenDeep = function(e) {
        return e && e.length ? p(e, 1 / 0) : []
    }, s.iteratee = ze, s.keys = X, s.map = function(e, t) {
        return y(e, g(t))
    }, s.matches = function(e) {
        return w(He({}, e))
    }, s.mixin = Q, s.negate = function(e) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return function() {
            return !e.apply(this, arguments)
        }
    }, s.once = function(e) {
        return H(2, e)
    }, s.pick = _e, s.slice = function(e, t, n) {
        var i = e ? e.length : 0;
        return n = n === J ? i : +n, i ? x(e, null == t ? 0 : +t, n) : []
    }, s.sortBy = function(e, t) {
        var n = 0;
        return t = g(t), y(y(e, function(e, i, o) {
            return {
                c: e,
                b: n++,
                a: t(e, i, o)
            }
        }).sort(function(e, t) {
            var n;
            e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                    var o = null === n,
                        r = n === J,
                        s = n == n,
                        a = null === i,
                        l = i === J,
                        u = i == i;
                    if (n > i && !a || !s || o && !l && u || r && u) {
                        n = 1;
                        break e
                    }
                    if (i > n && !o || !u || a && !r && s || l && s) {
                        n = -1;
                        break e
                    }
                }
                n = 0
            }
            return n || e.b - t.b
        }), b("c"))
    }, s.tap = function(e, t) {
        return t(e), e
    }, s.thru = function(e, t) {
        return t(e)
    }, s.toArray = function(e) {
        return _(e) ? e.length ? k(e) : [] : V(e)
    }, s.values = V, s.extend = qe, Q(s, s), s.clone = function(e) {
        return F(e) ? Ne(e) ? k(e) : C(e, X(e)) : e
    }, s.escape = function(e) {
        return (e = U(e)) && K.test(e) ? e.replace(Z, i) : e
    }, s.every = function(e, t, n) {
        return function(e, t) {
            var n = !0;
            return Te(e, function(e, i, o) {
                return n = !!t(e, i, o)
            }), n
        }(e, g(t = n ? J : t))
    }, s.find = N, s.forEach = D, s.has = function(e, t) {
        return null != e && pe.call(e, t)
    }, s.head = j, s.identity = G, s.indexOf = function(e, t, n) {
        var i = e ? e.length : 0;
        n = ((n = "number" == typeof n ? 0 > n ? ke(i + n, 0) : n : 0) || 0) - 1;
        for (var o = t == t; ++n < i;) {
            var r = e[n];
            if (o ? r === t : r != r) return n
        }
        return -1
    }, s.isArguments = L, s.isArray = Ne, s.isBoolean = function(e) {
        return !0 === e || !1 === e || M(e) && "[object Boolean]" == he.call(e)
    }, s.isDate = function(e) {
        return M(e) && "[object Date]" == he.call(e)
    }, s.isEmpty = function(e) {
        if (_(e) && (Ne(e) || W(e) || z(e.splice) || L(e))) return !e.length;
        for (var t in e)
            if (pe.call(e, t)) return !1;
        return !0
    }, s.isEqual = function(e, t) {
        return v(e, t)
    }, s.isFinite = function(e) {
        return "number" == typeof e && be(e)
    }, s.isFunction = z, s.isNaN = function(e) {
        return R(e) && e != +e
    }, s.isNull = function(e) {
        return null === e
    }, s.isNumber = R, s.isObject = F, s.isRegExp = function(e) {
        return F(e) && "[object RegExp]" == he.call(e)
    }, s.isString = W, s.isUndefined = function(e) {
        return e === J
    }, s.last = function(e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : J
    }, s.max = function(e) {
        return e && e.length ? t(e, G, P) : J
    }, s.min = function(e) {
        return e && e.length ? t(e, G, B) : J
    }, s.noConflict = function() {
        return ue._ === this && (ue._ = ve), this
    }, s.noop = function() {}, s.reduce = O, s.result = function(e, t, n) {
        return (t = null == e ? J : e[t]) === J && (t = n), z(t) ? t.call(e) : t
    }, s.size = function(e) {
        return null == e ? 0 : (e = _(e) ? e : X(e)).length
    }, s.some = function(e, t, n) {
        return T(e, g(t = n ? J : t))
    }, s.uniqueId = function(e) {
        var t = ++fe;
        return U(e) + t
    }, s.each = D, s.first = j, Q(s, function() {
        var e = {};
        return f(s, function(t, n) {
            pe.call(s.prototype, n) || (e[n] = t)
        }), e
    }(), {
        chain: !1
    }), s.VERSION = "4.5.1", Te("pop join replace reverse split push shift sort splice unshift".split(" "), function(e) {
        var t = (/^(?:replace|split)$/.test(e) ? String.prototype : ce)[e],
            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
            i = /^(?:pop|join|replace|shift)$/.test(e);
        s.prototype[e] = function() {
            var e = arguments;
            return i && !this.__chain__ ? t.apply(this.value(), e) : this[n](function(n) {
                return t.apply(n, e)
            })
        }
    }), s.prototype.toJSON = s.prototype.valueOf = s.prototype.value = function() {
        return t = this.__wrapped__, O(this.__actions__, function(t, n) {
            return n.func.apply(n.thisArg, e([t], n.args))
        }, t);
        var t
    }, (ae || se || {})._ = s, "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return s
    }) : ie && oe ? (re && ((oe.exports = s)._ = s), ie._ = s) : ue._ = s
}.call(this), window.mobileCheck = function() {
        var e, t = !1;
        return e = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = !0), t
    },
    function(e, t, n) {
        function i(e, t) {
            return typeof e === t
        }

        function o(e, t) {
            return !!~("" + e).indexOf(t)
        }

        function r() {
            return "function" != typeof t.createElement ? t.createElement(arguments[0]) : w ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
        }

        function s(e) {
            return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
                return t + n.toUpperCase()
            }).replace(/^-/, "")
        }

        function a(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        }

        function l(e) {
            return e.replace(/([A-Z])/g, function(e, t) {
                return "-" + t.toLowerCase()
            }).replace(/^ms-/, "-ms-")
        }

        function u(e, n, i, o) {
            var s, a, l, u, c = "modernizr",
                d = r("div"),
                p = function() {
                    var e = t.body;
                    return e || ((e = r(w ? "svg" : "body")).fake = !0), e
                }();
            if (parseInt(i, 10))
                for (; i--;)(l = r("div")).id = o ? o[i] : c + (i + 1), d.appendChild(l);
            return (s = r("style")).type = "text/css", s.id = "s" + c, (p.fake ? p : d).appendChild(s), p.appendChild(d), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(t.createTextNode(e)), d.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", u = y.style.overflow, y.style.overflow = "hidden", y.appendChild(p)), a = n(d, e), p.fake ? (p.parentNode.removeChild(p), y.style.overflow = u, y.offsetHeight) : d.parentNode.removeChild(d), !!a
        }

        function c(t, i) {
            var o = t.length;
            if ("CSS" in e && "supports" in e.CSS) {
                for (; o--;)
                    if (e.CSS.supports(l(t[o]), i)) return !0;
                return !1
            }
            if ("CSSSupportsRule" in e) {
                for (var r = []; o--;) r.push("(" + l(t[o]) + ":" + i + ")");
                return u("@supports (" + (r = r.join(" or ")) + ") { #modernizr { position: absolute; } }", function(e) {
                    return "absolute" == getComputedStyle(e, null).position
                })
            }
            return n
        }

        function d(e, t, a, l) {
            function u() {
                p && (delete C.style, delete C.modElem)
            }
            if (l = !i(l, "undefined") && l, !i(a, "undefined")) {
                var d = c(e, a);
                if (!i(d, "undefined")) return d
            }
            for (var p, f, h, v, g, m = ["modernizr", "tspan", "samp"]; !C.style && m.length;) p = !0, C.modElem = r(m.shift()), C.style = C.modElem.style;
            for (h = e.length, f = 0; h > f; f++)
                if (v = e[f], g = C.style[v], o(v, "-") && (v = s(v)), C.style[v] !== n) {
                    if (l || i(a, "undefined")) return u(), "pfx" != t || v;
                    try {
                        C.style[v] = a
                    } catch (e) {}
                    if (C.style[v] != g) return u(), "pfx" != t || v
                }
            return u(), !1
        }

        function p(e, t, n, o, r) {
            var s = e.charAt(0).toUpperCase() + e.slice(1),
                l = (e + " " + x.join(s + " ") + s).split(" ");
            return i(t, "string") || i(t, "undefined") ? d(l, t, o, r) : function(e, t, n) {
                var o;
                for (var r in e)
                    if (e[r] in t) return !1 === n ? e[r] : i(o = t[e[r]], "function") ? a(o, n || t) : o;
                return !1
            }(l = (e + " " + k.join(s + " ") + s).split(" "), t, n)
        }

        function f(e, t, i) {
            return p(e, n, n, t, i)
        }
        var h = [],
            v = [],
            g = {
                _version: "3.3.1",
                _config: {
                    classPrefix: "",
                    enableClasses: !0,
                    enableJSClass: !0,
                    usePrefixes: !0
                },
                _q: [],
                on: function(e, t) {
                    var n = this;
                    setTimeout(function() {
                        t(n[e])
                    }, 0)
                },
                addTest: function(e, t, n) {
                    v.push({
                        name: e,
                        fn: t,
                        options: n
                    })
                },
                addAsyncTest: function(e) {
                    v.push({
                        name: null,
                        fn: e
                    })
                }
            },
            m = function() {};
        m.prototype = g, (m = new m).addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
        var y = t.documentElement,
            w = "svg" === y.nodeName.toLowerCase(),
            b = "Moz O ms Webkit",
            x = g._config.usePrefixes ? b.split(" ") : [];
        g._cssomPrefixes = x;
        var k = g._config.usePrefixes ? b.toLowerCase().split(" ") : [];
        g._domPrefixes = k;
        var T = {
            elem: r("modernizr")
        };
        m._q.push(function() {
            delete T.elem
        });
        var C = {
            style: T.elem.style
        };
        m._q.unshift(function() {
                delete C.style
            }), g.testAllProps = p, g.testAllProps = f, m.addTest("flexbox", f("flexBasis", "1px", !0)), m.addTest("csstransforms", function() {
                return -1 === navigator.userAgent.indexOf("Android 2.") && f("transform", "scale(1)", !0)
            }),
            function() {
                var e, t, n, o, r, s;
                for (var a in v)
                    if (v.hasOwnProperty(a)) {
                        if (e = [], (t = v[a]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                            for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                        for (o = i(t.fn, "function") ? t.fn() : t.fn, r = 0; r < e.length; r++) 1 === (s = e[r].split(".")).length ? m[s[0]] = o : (!m[s[0]] || m[s[0]] instanceof Boolean || (m[s[0]] = new Boolean(m[s[0]])), m[s[0]][s[1]] = o), h.push((o ? "" : "no-") + s.join("-"))
                    }
            }(),
            function(e) {
                var t = y.className,
                    n = m._config.classPrefix || "";
                if (w && (t = t.baseVal), m._config.enableJSClass) {
                    var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                    t = t.replace(i, "$1" + n + "js$2")
                }
                m._config.enableClasses && (t += " " + n + e.join(" " + n), w ? y.className.baseVal = t : y.className = t)
            }(h), delete g.addTest, delete g.addAsyncTest;
        for (var S = 0; S < m._q.length; S++) m._q[S]();
        e.Modernizr = m
    }(window, document),
    function(e) {
        e.fn.prepareTransition = function() {
            return this.each(function() {
                var t = e(this);
                t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                    t.removeClass("is-transitioning")
                });
                var n = 0;
                e.each(["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"], function(e, i) {
                    n || (n = parseFloat(t.css(i)))
                }), 0 != n && (t.addClass("is-transitioning"), t[0].offsetWidth)
            })
        }
    }(jQuery),
    function(e, t) {
        var n, i = e.jQuery || e.Cowboy || (e.Cowboy = {});
        i.throttle = n = function(e, n, o, r) {
            function s() {
                function i() {
                    l = +new Date, o.apply(s, c)
                }
                var s = this,
                    u = +new Date - l,
                    c = arguments;
                r && !a && i(), a && clearTimeout(a), r === t && u > e ? i() : !0 !== n && (a = setTimeout(r ? function() {
                    a = t
                } : i, r === t ? e - u : e))
            }
            var a, l = 0;
            return "boolean" != typeof n && (r = o, o = n, n = t), i.guid && (s.guid = o.guid = o.guid || i.guid++), s
        }, i.debounce = function(e, i, o) {
            return o === t ? n(e, i, !1) : n(e, o, !1 !== i)
        }
    }(this);
  /*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});